export const fontLibrary = {
  "A Love of Thunder": [
    "Normal,Normal"
  ],
  "ABeeZee": [
    "Normal,Italic"
  ],
  "Abel": [
    "Normal,Normal"
  ],
  "Aboriginal Sans": [
    "Bold,Normal"
  ],
  "Aclonica": [
    "Normal,Normal"
  ],
  "Acme": [
    "Normal,Normal"
  ],
  "After Shok": [
    "Normal,Normal"
  ],
  "Agency FB": [
    "Bold,Normal"
  ],
  "Airmole": [
    "Normal,Normal"
  ],
  "Akronim": [
    "Normal,Normal"
  ],
  "Aladin": [
    "Normal,Normal"
  ],
  "Alba": [
    "Normal,Normal"
  ],
  "Alba Super": [
    "Normal,Normal"
  ],
  "Albanian": [
    "Normal,Normal"
  ],
  "Alegreya": [
    "Bold,Italic"
  ],
  "Alice": [
    "Normal,Normal"
  ],
  "Alice0 Lao": [
    "Normal,Normal"
  ],
  "Allan": [
    "Normal,Normal"
  ],
  "Amaranth": [
    "Bold,Italic"
  ],
  "Andalus": [
    "Normal,Normal"
  ],
  "AngsanaUPC": [
    "Normal,Normal"
  ],
  "Anhedonia": [
    "Normal,Normal"
  ],
  "Anton": [
    "Normal,Normal"
  ],
  "AntoniousJ": [
    "Normal,Normal"
  ],
  "AntoniousOL": [
    "Normal,Normal"
  ],
  "Arabic Transparent": [
    "Normal,Normal"
  ],
  "Arabic Typesetting": [
    "Normal,Normal"
  ],
  "Arabic Web": [
    "Normal,Normal"
  ],
  "ArabicKufiSSK": [
    "Normal,Normal"
  ],
  "ArabicRiyadhSSK": [
    "Normal,Normal"
  ],
  "Arial": [
    "Normal,Normal"
  ],
  "ArTarumianMatenagir": [
    "Normal,Normal"
  ],
  "Babe Bamboo": [
    "Normal,Normal"
  ],
  "Back to Bay 6": [
    "Normal,Normal"
  ],
  "BaltHelvetica": [
    "Normal,Normal"
  ],
  "Cabin": [
    "Bold,Italic"
  ],
  "Calibri": [
    "Bold,Normal"
  ],
  "Californian FB": [
    "Normal,Normal"
  ],
  "CaligulaDodgy": [
    "Normal,Normal"
  ],
  "Capriola": [
    "Normal,Normal"
  ],
  "Damion": [
    "Normal,Normal"
  ],
  "Dark Horse": [
    "Normal,Normal"
  ],
  "David": [
    "Normal,Normal"
  ],
  "David Transparent": [
    "Normal,Normal"
  ],
  "Dead Alive": [
    "Normal,Normal"
  ],
  "Edmunds": [
    "Normal,Normal"
  ],
  "Edwardian Script ITC": [
    "Normal,Normal"
  ],
  "Eight Track program 3": [
    "Normal,Normal"
  ],
  "Elbjorg": [
    "Normal,Normal"
  ],
  "Electroharmonix": [
    "Normal,Normal"
  ],
  "Fanatika One": [
    "Normal,Normal"
  ],
  "Fat": [
    "Normal,Normal"
  ],
  "Fatty": [
    "Normal,Normal"
  ],
  "Felix Titling": [
    "Normal,Normal"
  ],
  "Gabriela": [
    "Normal,Normal"
  ],
  "Galindo": [
    "Normal,Normal"
  ],
  "Garamond": [
    "Normal,Italic"
  ],
  "Gas Huffer Phat": [
    "Normal,Normal"
  ],
  "Gautami": [
    "Normal,Normal"
  ],
  "Hacknslash": [
    "Normal,Normal"
  ],
  "Haettenschweiler": [
    "Normal,Normal"
  ],
  "Hall Fetica": [
    "Normal,Normal"
  ],
  "Hallandale Deco Bd It. Smc JL": [
    "Normal,Normal"
  ],
  "Hallisey": [
    "Normal,Normal"
  ],
  "I hate Comic Sans": [
    "Normal,Normal"
  ],
  "I Want My TTR!": [
    "Normal,Normal"
  ],
  "Iceberg": [
    "Normal,Normal"
  ],
  "IkonWrite": [
    "Normal,Normal"
  ],
  "JackCondensed": [
    "Normal,Normal"
  ],
  "JackInput": [
    "Normal,Normal"
  ],
  "JackRoman": [
    "Normal,Normal"
  ],
  "JaggaPoint": [
    "Normal,Normal"
  ],
  "Jamiro": [
    "Normal,Normal"
  ],
  "K.P. Duty Overtime JL": [
    "Normal,Normal"
  ],
  "KabanaBold": [
    "Normal,Normal"
  ],
  "KabanaBook": [
    "Normal,Normal"
  ],
  "Kabel": [
    "Normal,Normal"
  ],
  "KabinConMedDB": [
    "Normal,Normal"
  ],
  "Lab Bats": [
    "Normal,Normal"
  ],
  "Laffayette Comic Pro": [
    "Normal,Normal"
  ],
  "Lancelot": [
    "Normal,Normal"
  ],
  "Latha": [
    "Normal,Normal"
  ],
  "Macaroni": [
    "Normal,Normal"
  ],
  "Mad scientist": [
    "Normal,Normal"
  ],
  "Mael": [
    "Normal,Normal"
  ],
  "Magehunter": [
    "Normal,Normal"
  ],
  "Magic:the Gathering": [
    "Normal,Normal"
  ],
  "Nails": [
    "Normal,Normal"
  ],
  "naked monk": [
    "Normal,Normal"
  ],
  "Nameless Harbor": [
    "Normal,Normal"
  ],
  "Napapiiri": [
    "Normal,Normal"
  ],
  "Narcotix": [
    "Normal,Normal"
  ],
  "Oblivious font": [
    "Normal,Normal"
  ],
  "Occasion DB": [
    "Normal,Normal"
  ],
  "OCR A Extended": [
    "Normal,Normal"
  ],
  "Off Kilter R (BRK)": [
    "Normal,Normal"
  ],
  "Office": [
    "Normal,Normal"
  ],
  "Pacifico": [
    "Normal,Normal"
  ],
  "Papyrus": [
    "Normal,Normal"
  ],
  "Parchment": [
    "Normal,Normal"
  ],
  "Pastor of Muppets": [
    "Normal,Normal"
  ],
  "Patriot": [
    "Normal,Normal"
  ],
  "Quadrangle": [
    "Normal,Normal"
  ],
  "QUAKE": [
    "Normal,Normal"
  ],
  "Quartermain Condensed": [
    "Normal,Normal"
  ],
  "QuickExpress": [
    "Normal,Normal"
  ],
  "Quinquefoliolate": [
    "Normal,Normal"
  ],
  "Raavi": [
    "Normal,Normal"
  ],
  "Radiated Pancake": [
    "Normal,Normal"
  ],
  "Radonator Anorexia": [
    "Normal,Normal"
  ],
  "Rainy Days": [
    "Normal,Normal"
  ],
  "Raketta From Mars": [
    "Normal,Normal"
  ],
  "Sad Jane": [
    "Normal,Normal"
  ],
  "Saffron": [
    "Normal,Normal"
  ],
  "Sagittarius": [
    "Normal,Normal"
  ],
  "Sail": [
    "Normal,Normal"
  ],
  "Sakkal Majalla": [
    "Normal,Normal"
  ],
  "Takeout": [
    "Normal,Normal"
  ],
  "Tangerine": [
    "Normal,Normal"
  ],
  "Tangerine XCn": [
    "Normal,Normal"
  ],
  "Tanline": [
    "Normal,Normal"
  ],
  "Tanne DB": [
    "Normal,Normal"
  ],
  "u26fog": [
    "Normal,Normal"
  ],
  "u27fog": [
    "Normal,Normal"
  ],
  "Ubuntu Condensed": [
    "Normal,Normal"
  ],
  "Ultra": [
    "Normal,Normal"
  ],
  "Umbles": [
    "Normal,Normal"
  ],
  "VA Pe DB": [
    "Normal,Normal"
  ],
  "Verdana": [
    "Normal,Normal"
  ],
  "Verticalization": [
    "Normal,Normal"
  ],
  "Viner Hand ITC": [
    "Normal,Normal"
  ],
  "VIPER NORA": [
    "Normal,Normal"
  ],
  "W.J. Pearce hollow": [
    "Normal,Normal"
  ],
  "Wait And Bleed": [
    "Normal,Normal"
  ],
  "WaldauDB": [
    "Normal,Normal"
  ],
  "WallStreet": [
    "Normal,Normal"
  ],
  "Walrod": [
    "Normal,Normal"
  ],
  "Xacto Blade": [
    "Normal,Normal"
  ],
  "XBAND Rough": [
    "Normal,Normal"
  ],
  "Xdvng": [
    "Normal,Normal"
  ],
  "Xefus": [
    "Normal,Normal"
  ],
  "Xeroprint": [
    "Normal,Normal"
  ],
  "y.n.w.u.a.y": [
    "Normal,Normal"
  ],
  "Yanone Kaffeesatz Regular": [
    "Normal,Normal"
  ],
  "Year 2000 Replicant": [
    "Normal,Normal"
  ],
  "Year 3000 Pro": [
    "Normal,Normal"
  ],
  "Year supply of fairy cakes": [
    "Normal,Normal"
  ],
  "Z machine (sRB)": [
    "Normal,Normal"
  ],
  "Zachary Hanson": [
    "Normal,Normal"
  ],
  "Zamboni Joe Expanded": [
    "Normal,Normal"
  ],
  "Zebra Parade": [
    "Normal,Normal"
  ],
  "Arial Ykt": [
    "Normal,Normal"
  ],
  "ArTarumianHamagumar": [
    "Normal,Normal"
  ],
  "ArTarumianKamar": [
    "Normal,Normal"
  ],
  "ArTarumianMHarvats": [
    "Normal,Normal"
  ],
  "Arvo": [
    "Normal,Normal"
  ],
  "Astloch": [
    "Normal,Normal"
  ],
  "Astron Boy Video": [
    "Normal,Normal"
  ],
  "BaltOptima": [
    "Normal,Normal"
  ],
  "BaltUniversity": [
    "Normal,Normal"
  ],
  "Bangers": [
    "Normal,Normal"
  ],
  "Baroness Kuffner": [
    "Normal,Normal"
  ],
  "Basic": [
    "Normal,Normal"
  ],
  "Baskerville Old Face": [
    "Normal,Normal"
  ],
  "Baumans": [
    "Normal,Normal"
  ],
  "BeachType": [
    "Normal,Normal"
  ],
  "Bearpaw": [
    "Normal,Normal"
  ],
  "Bebas Neue Book": [
    "Normal,Normal"
  ],
  "Carbon Block": [
    "Normal,Normal"
  ],
  "Cassatta Zig": [
    "Normal,Normal"
  ],
  "Castellar": [
    "Normal,Normal"
  ],
  "Centaur": [
    "Normal,Normal"
  ],
  "Century": [
    "Normal,Normal"
  ],
  "Chango": [
    "Normal,Normal"
  ],
  "Cheetah": [
    "Normal,Normal"
  ],
  "Chewy": [
    "Normal,Normal"
  ],
  "Chey 1 SILManuscriptL": [
    "Normal,Normal"
  ],
  "CHICASyMUJERES": [
    "Normal,Normal"
  ],
  "Dead World": [
    "Normal,Normal"
  ],
  "Deftone Stylus": [
    "Normal,Normal"
  ],
  "Devonshire": [
    "Normal,Normal"
  ],
  "District": [
    "Normal,Normal"
  ],
  "DK Cool Crayon": [
    "Normal,Normal"
  ],
  "DK Crayon Crumble": [
    "Normal,Normal"
  ],
  "DokChampa": [
    "Normal,Normal"
  ],
  "Dorsa": [
    "Normal,Normal"
  ],
  "Dosis": [
    "Normal,Normal",
  ],
  "Doulos SIL": [
    "Normal,Normal"
  ],
  "Elsie": [
    "Normal,Normal"
  ],
  "Englebert": [
    "Normal,Normal"
  ],
  "ER Architect": [
    "Normal,Normal"
  ],
  "Eras Medium ITC": [
    "Normal,Normal"
  ],
  "EraserDust": [
    "Normal,Normal"
  ],
  "Estrangelo Edessa": [
    "Normal,Normal"
  ],
  "Feuerfeste": [
    "Normal,Normal"
  ],
  "Fixed Miriam Transparent": [
    "Normal,Normal"
  ],
  "Flower Ornaments": [
    "Normal,Normal"
  ],
  "Fondamento": [
    "Normal,Normal"
  ],
  "Forte": [
    "Normal,Normal"
  ],
  "France": [
    "Normal,Normal"
  ],
  "Franklin Gothic Book": [
    "Normal,Normal"
  ],
  "Franklin Gothic Medium": [
    "Normal,Normal",
  ],
  "Franklin Gothic Medium Cond": [
    "Normal,Normal"
  ],
  "FrankRuehl": [
    "Normal,Normal"
  ],
  "Geeves": [
    "Normal,Normal"
  ],
  "GENUINE": [
    "Normal,Normal"
  ],
  "GF Ordner Normal": [
    "Normal,Normal"
  ],
  "GhostBayou": [
    "Normal,Normal"
  ],
  "Ghostmeat": [
    "Normal,Normal"
  ],
  "GiantTigers": [
    "Normal,Normal"
  ],
  "Gigi": [
    "Normal,Normal"
  ],
  "Gilgongo Doro": [
    "Normal,Normal"
  ],
  "Gill Sans MT Condensed": [
    "Normal,Normal"
  ],
  "Gloucester MT Extra Condensed": [
    "Normal,Normal"
  ],
  "HamburgerHeaven": [
    "Normal,Normal"
  ],
  "Hammerhead": [
    "Normal,Normal",
  ],
  "HammerheadOutline": [
    "Normal,Normal"
  ],
  "Handlee": [
    "Normal,Normal"
  ],
  "HanWangFangSongMedium": [
    "Normal,Normal"
  ],
  "HanWangHeiHeavy": [
    "Normal,Normal"
  ],
  "HanWangHeiLight": [
    "Normal,Normal"
  ],
  "HanWangMingHeavy": [
    "Normal,Normal"
  ],
  "HanWangMingLight": [
    "Normal,Normal"
  ],
  "HanWangMingMediumChuIn": [
    "Normal,Normal"
  ],
  "ILL oMen": [
    "Normal,Normal"
  ],
  "Impact": [
    "Normal,Normal"
  ],
  "Impossibilium (BRK)": [
    "Normal,Normal"
  ],
  "Imprint MT Shadow": [
    "Normal,Normal"
  ],
  "Inconsolata": [
    "Normal,Normal"
  ],
  "Independence": [
    "Normal,Normal"
  ],
  "Industrial": [
    "Normal,Normal"
  ],
  "Informal Roman": [
    "Normal,Normal"
  ],
  "Insane Hours": [
    "Normal,Normal"
  ],
  "International Super Hero Exp": [
    "Normal,Normal"
  ],
  "Jangly Bounce": [
    "Normal,Normal"
  ],
  "Japanese": [
    "Normal,Normal"
  ],
  "Jerk": [
    "Normal,Normal"
  ],
  "Jerkoff": [
    "Normal,Normal"
  ],
  "JG ChamVN": [
    "Normal,Normal"
  ],
  "Joint": [
    "Normal,Normal"
  ],
  "Jokerman": [
    "Normal,Normal"
  ],
  "Juice ITC": [
    "Normal,Normal"
  ],
  "Julee": [
    "Normal,Normal"
  ],
  "Junegull": [
    "Normal,Normal"
  ],
  "Kantor Ligatures": [
    "Normal,Normal"
  ],
  "Kaptain Toupe": [
    "Normal,Normal"
  ],
  "Kartika": [
    "Normal,Normal"
  ],
  "Kavoon": [
    "Normal,Normal"
  ],
  "Kenia": [
    "Normal,Normal"
  ],
  "KG Blank Space Sketch": [
    "Normal,Normal"
  ],
  "KG Broken Vessels Sketch": [
    "Normal,Normal"
  ],
  "KG Ten Thousand Reasons": [
    "Normal,Normal"
  ],
  "KG Ten Thousand Reasons Alt": [
    "Normal,Normal"
  ],
  "KidTYPEPaint": [
    "Normal,Normal"
  ],
  "Lazuri ATHLETIC": [
    "Normal,Normal"
  ],
  "LeedsCyr Koi8_4": [
    "Normal,Normal"
  ],
  "LeedsCyr Koi8_5": [
    "Normal,Normal"
  ],
  "Lefferts Corners  2": [
    "Normal,Normal"
  ],
  "Leger": [
    "Normal,Normal"
  ],
  "Lemon": [
    "Normal,Normal"
  ],
  "Letter Set C": [
    "Normal,Normal"
  ],
  "LetterGotLBol": [
    "Normal,Normal"
  ],
  "Lewis F. Day 191": [
    "Normal,Normal"
  ],
  "Libritabs": [
    "Normal,Normal"
  ],
  "Maharlika": [
    "Normal,Normal"
  ],
  "Maiandra GD": [
    "Normal,Normal"
  ],
  "Makisupa": [
    "Normal,Normal"
  ],
  "MammaGamma": [
    "Normal,Normal"
  ],
  "MandarinSCD": [
    "Normal,Normal"
  ],
  "Mangal": [
    "Normal,Normal"
  ],
  "Many moods of Moe": [
    "Normal,Normal"
  ],
  "Marburg DB": [
    "Normal,Normal"
  ],
  "Marfhaus": [
    "Normal,Normal"
  ],
  "Marlo": [
    "Normal,Normal"
  ],
  "Narkisim": [
    "Normal,Normal"
  ],
  "National First Font": [
    "Normal,Normal"
  ],
  "National Primary": [
    "Normal,Normal"
  ],
  "Native Alien Extended": [
    "Normal,Normal"
  ],
  "Nauvoo": [
    "Normal,Normal"
  ],
  "Nebullium": [
    "Normal,Normal"
  ],
  "NEOLITH": [
    "Normal,Normal"
  ],
  "Neuropolitical": [
    "Normal,Normal"
  ],
  "Nexa Slab Regular": [
    "Normal,Normal"
  ],
  "Offside": [
    "Normal,Normal"
  ],
  "Old English Text MT": [
    "Normal,Normal"
  ],
  "Old Oak": [
    "Normal,Normal"
  ],
  "Omicron Zeta Slant": [
    "Normal,Normal"
  ],
  "Onyx": [
    "Normal,Normal"
  ],
  "Open Sans": [
    "Normal,Normal"
  ],
  "orange juice": [
    "Normal,Normal"
  ],
  "Orbitron": [
    "Normal,Normal"
  ],
  "Overlock": [
    "Normal,Normal"
  ],
  "Piedra": [
    "Normal,Normal"
  ],
  "pills are good": [
    "Normal,Normal"
  ],
  "Playball": [
    "Normal,Normal"
  ],
  "Playbill": [
    "Normal,Normal"
  ],
  "Pooja": [
    "Normal,Normal"
  ],
  "Poor Richard": [
    "Normal,Normal"
  ],
  "Pravda Fixed Pitch": [
    "Normal,Normal"
  ],
  "Pristina": [
    "Normal,Normal"
  ],
  "Pussycat": [
    "Normal,Normal"
  ],
  "Quintessential": [
    "Normal,Normal"
  ],
  "Quorum Md BT": [
    "Normal,Normal"
  ],
  "Raleigh Md BT": [
    "Normal,Normal"
  ],
  "Raleway": [
    "Normal,Normal",
  ],
  "Rambo Killer ": [
    "Normal,Normal"
  ],
  "Rancho": [
    "Normal,Normal"
  ],
  "Randi": [
    "Normal,Normal"
  ],
  "Random Voter": [
    "Normal,Normal"
  ],
  "RANXEROX": [
    "Normal,Normal"
  ],
  "Raptor Attack": [
    "Normal,Normal"
  ],
  "Rat Man Bane": [
    "Normal,Normal"
  ],
  "Raveflire 2.0": [
    "Normal,Normal"
  ],
  "Saltire": [
    "Normal,Normal"
  ],
  "Sam is my Name": [
    "Normal,Normal"
  ],
  "samarin": [
    "Normal,Normal"
  ],
  "Samba is Dead": [
    "Normal,Normal"
  ],
  "Sand": [
    "Normal,Normal"
  ],
  "SandCastles": [
    "Normal,Normal"
  ],
  "Sansation": [
    "Normal,Normal"
  ],
  "Satisfy": [
    "Normal,Normal"
  ],
  "Saulteaux": [
    "Normal,Normal"
  ],
  "Tannenberg Fett": [
    "Normal,Normal"
  ],
  "TANTOR": [
    "Normal,Normal"
  ],
  "Tarnished Halo": [
    "Normal,Normal"
  ],
  "Taskeksem inflamerat": [
    "Normal,Normal"
  ],
  "Tattoo No1": [
    "Normal,Normal"
  ],
  "Tempus Sans ITC": [
    "Normal,Normal"
  ],
  "Thai7BangkokSSK": [
    "Normal,Normal"
  ],
  "TNR Liborius ": [
    "Normal,Normal"
  ],
  "Tornado": [
    "Normal,Normal"
  ],
  "Trebuchet MS": [
    "Normal,Normal",
  ],
  "UNCONFORM": [
    "Normal,Normal"
  ],
  "Under attack skew": [
    "Normal,Normal"
  ],
  "Undercover": [
    "Normal,Normal"
  ],
  "Unionform": [
    "Normal,Normal"
  ],
  "Univers 57 Condensed": [
    "Normal,Normal"
  ],
  "Univers LT 57 Condensed": [
    "Normal,Normal"
  ],
  "Unkempt": [
    "Normal,Normal"
  ],
  "Vipnagorgialla": [
    "Normal,Normal"
  ],
  "Vitamin": [
    "Normal,Normal"
  ],
  "Vivienne": [
    "Normal,Normal"
  ],
  "Vixar ASCI": [
    "Normal,Normal"
  ],
  "Vladimir Script": [
    "Normal,Normal"
  ],
  "Vollkorn Regular": [
    "Normal,Normal"
  ],
  "Volt": [
    "Normal,Normal"
  ],
  "VPS Tuyen Duc": [
    "Normal,Normal"
  ],
  "VPS Tuyen Duc Hoa": [
    "Normal,Normal"
  ],
  "Vrinda": [
    "Normal,Normal"
  ],
  "Warp 1": [
    "Normal,Normal"
  ],
  "Webdings": [
    "Normal,Normal"
  ],
  "Wellfleet": [
    "Normal,Normal"
  ],
  "Wendy One": [
    "Normal,Normal"
  ],
  "Wide Latin": [
    "Normal,Normal"
  ],
  "Wingdings": [
    "Normal,Normal"
  ],
  "Wingdings 2": [
    "Normal,Normal"
  ],
  "Wingdings 3": [
    "Normal,Normal"
  ],
  "wmtrees1": [
    "Normal,Normal"
  ],
  "Woods Cree": [
    "Normal,Normal"
  ],
  "Xmas 97": [
    "Normal,Normal"
  ],
  "Xolto": [
    "Normal,Normal"
  ],
  "Xomic": [
    "Normal,Normal"
  ],
  "Yellow Dog": [
    "Normal,Normal"
  ],
  "Yellowjacket Expanded": [
    "Normal,Normal"
  ],
  "Yellowjacket Rotate": [
    "Normal,Normal"
  ],
  "YellowSubmarine": [
    "Normal,Normal"
  ],
  "Yellowtail": [
    "Normal,Normal"
  ],
  "Yesterday DB": [
    "Normal,Normal"
  ],
  "YouYuan": [
    "Normal,Normal"
  ],
  "YrBkMess": [
    "Normal,Normal"
  ],
  "Zhang QA": [
    "Normal,Normal"
  ],
  "Zinc Boomerang": [
    "Normal,Normal"
  ],
  "Zone23_Dreamtime 923": [
    "Normal,Normal"
  ],
  "Zymbols": [
    "Normal,Normal"
  ],
  "Bebas Neue Regular": [
    "Normal,Normal"
  ],
  "Belleza": [
    "Normal,Normal"
  ],
  "Belphebe": [
    "Normal,Normal"
  ],
  "Berlin Sans FB": [
    "Normal,Normal"
  ],
  "Bernard MT Condensed": [
    "Normal,Normal"
  ],
  "Berthside": [
    "Normal,Normal"
  ],
  "Bilbo": [
    "Normal,Normal"
  ],
  "Birds of a Feather": [
    "Normal,Normal"
  ],
  "Blackadder ITC": [
    "Normal,Normal"
  ],
  "Blue Highway Linocut": [
    "Normal,Normal"
  ],
  "Boogaloo": [
    "Normal,Normal"
  ],
  "Bookshelf Symbol 7": [
    "Normal,Normal"
  ],
  "Bradley Hand ITC": [
    "Normal,Normal"
  ],
  "Broadway": [
    "Normal,Normal"
  ],
  "Bubble 1": [
    "Normal,Normal"
  ],
  "Butterflies": [
    "Normal,Normal"
  ],
  "Chiller": [
    "Normal,Normal"
  ],
  "Chinese Cally TFB": [
    "Normal,Normal"
  ],
  "Chow Fun": [
    "Normal,Normal"
  ],
  "Chupada": [
    "Normal,Normal"
  ],
  "Ciula": [
    "Normal,Normal"
  ],
  "CloisterOpenFace BT": [
    "Normal,Normal"
  ],
  "Code Pro": [
    "Normal,Normal"
  ],
  "Code Pro Demo": [
    "Normal,Normal"
  ],
  "Code Pro LC": [
    "Normal,Normal"
  ],
  "Colonna MT": [
    "Normal,Normal"
  ],
  "Combo": [
    "Normal,Normal"
  ],
  "Comic Sans MS": [
    "Normal,Normal"
  ],
  "Condiment": [
    "Normal,Normal"
  ],
  "Cookie": [
    "Normal,Normal"
  ],
  "Cordia New": [
    "Normal,Normal"
  ],
  "Core Sans A 45 Regular": [
    "Normal,Normal"
  ],
  "Core Sans A 55 Medium": [
    "Normal,Normal"
  ],
  "Courgette": [
    "Normal,Normal"
  ],
  "Courier New": [
    "Normal,Normal",
  ],
  "Cream and sugar": [
    "Normal,Normal"
  ],
  "Cree": [
    "Normal,Normal"
  ],
  "CrimeFighter BB": [
    "Normal,Normal"
  ],
  "Croat": [
    "Normal,Normal"
  ],
  "Curlz MT": [
    "Normal,Normal"
  ],
  "Cursiv": [
    "Normal,Normal"
  ],
  "Drawing Guides": [
    "Normal,Normal"
  ],
  "Dutch823 BT": [
    "Normal,Normal"
  ],
  "Freestyle Script": [
    "Normal,Normal"
  ],
  "French Script MT": [
    "Normal,Normal"
  ],
  "FZ JAZZY 12 CRACKED": [
    "Normal,Normal"
  ],
  "Gnuolane Rg": [
    "Normal,Normal"
  ],
  "Good Head": [
    "Normal,Normal"
  ],
  "Goudy Stout": [
    "Normal,Normal"
  ],
  "Graduate": [
    "Normal,Normal"
  ],
  "Greek": [
    "Normal,Normal"
  ],
  "Greek Becker": [
    "Normal,Normal"
  ],
  "Griffy": [
    "Normal,Normal"
  ],
  "Groovalicious Tweak": [
    "Normal,Normal"
  ],
  "Ground Zero": [
    "Normal,Normal"
  ],
  "Gruppo": [
    "Normal,Normal"
  ],
  "Guarani_Roman": [
    "Normal,Normal"
  ],
  "HanWangYanKai": [
    "Normal,Normal"
  ],
  "HanWangYenHeavy": [
    "Normal,Normal"
  ],
  "HanWangYenLight": [
    "Normal,Normal"
  ],
  "HarlowD": [
    "Normal,Normal"
  ],
  "Harrington": [
    "Normal,Normal"
  ],
  "HebrewUniversal": [
    "Normal,Normal"
  ],
  "Helvetica CE Narrow": [
    "Normal,Normal",
  ],
  "Helvetica LT Std  steevo harvie": [
    "Normal,Normal"
  ],
  "Helvetica LT Std Compressed": [
    "Normal,Normal"
  ],
  "Helvetica LT Std ExtCompressed": [
    "Normal,Normal"
  ],
  "Helvetica LT Std UltCompressed": [
    "Normal,Normal"
  ],
  "HelveticaNeue Extended": [
    "Normal,Normal",
  ],
  "HelveticaNeue MediumCond": [
    "Normal,Normal",
  ],
  "HelveticaNeueLT Std": [
    "Normal,Normal"
  ],
  "HelveticaNeueLT Std Cn": [
    "Normal,Normal",
  ],
  "High Tower Text": [
    "Normal,Normal",
  ],
  "Hollywood": [
    "Normal,Normal"
  ],
  "HoratioDMed": [
    "Normal,Normal"
  ],
  "Horley Old Style MT": [
    "Normal,Normal"
  ],
  "Humeur": [
    "Normal,Normal"
  ],
  "HVD Comic Serif Pro": [
    "Normal,Normal"
  ],
  "Interstate": [
    "Normal,Normal",
  ],
  "Interstate Mono": [
    "Normal,Normal"
  ],
  "Intramural JL": [
    "Normal,Normal"
  ],
  "Intro ": [
    "Normal,Normal"
  ],
  "Intro Book": [
    "Normal,Normal"
  ],
  "Intro Book Alt": [
    "Normal,Normal"
  ],
  "Intro Book Caps": [
    "Normal,Normal"
  ],
  "Intro Cond 2": [
    "Normal,Normal"
  ],
  "Intro Cond Caps 2": [
    "Normal,Normal"
  ],
  "Intro Inline": [
    "Normal,Normal"
  ],
  "Intro Regular": [
    "Normal,Normal"
  ],
  "Intro Regular Alt": [
    "Normal,Normal"
  ],
  "Intro Regular Caps": [
    "Normal,Normal"
  ],
  "Irezumi": [
    "Normal,Normal"
  ],
  "Irmologion": [
    "Normal,Normal"
  ],
  "Italianno": [
    "Normal,Normal"
  ],
  "Justinian": [
    "Normal,Normal"
  ],
  "JustSmashing": [
    "Normal,Normal"
  ],
  "KoffeeDBol": [
    "Normal,Normal"
  ],
  "Kristen ITC": [
    "Normal,Normal"
  ],
  "Kunstler Script": [
    "Normal,Normal"
  ],
  "Lifetime": [
    "Normal,Normal"
  ],
  "Limelight": [
    "Normal,Normal"
  ],
  "Lindas Lament": [
    "Normal,Normal"
  ],
  "LiquidCrystal": [
    "Normal,Normal"
  ],
  "Liquidism part 2": [
    "Normal,Normal"
  ],
  "Lizzard": [
    "Normal,Normal"
  ],
  "Lobster": [
    "Normal,Normal"
  ],
  "Lois Ann": [
    "Normal,Normal"
  ],
  "Lora": [
    "Normal,Normal"
  ],
  "Love Letters": [
    "Normal,Normal"
  ],
  "Lowtech": [
    "Normal,Normal"
  ],
  "Lucida Console": [
    "Normal,Normal"
  ],
  "Lucida Sans": [
    "Normal,Italic"
  ],
  "Lucida Sans Unicode": [
    "Normal,Normal"
  ],
  "Lunch time": [
    "Normal,Normal"
  ],
  "Luteous Industrious": [
    "Normal,Normal"
  ],
  "Luxo": [
    "Normal,Normal"
  ],
  "MarlonDB": [
    "Normal,Normal"
  ],
  "Marquee Moon": [
    "Normal,Normal"
  ],
  "Mars Police": [
    "Normal,Normal"
  ],
  "Martel": [
    "Normal,Normal"
  ],
  "Matura MT Script Capitals": [
    "Normal,Normal"
  ],
  "Menuetto": [
    "Normal,Normal"
  ],
  "Merienda": [
    "Normal,Normal"
  ],
  "Metamorphous": [
    "Normal,Normal"
  ],
  "Mexacali": [
    "Normal,Normal"
  ],
  "Microsoft Sans Serif": [
    "Normal,Normal"
  ],
  "Mikey Jax": [
    "Normal,Normal"
  ],
  "Milkfresh": [
    "Normal,Normal"
  ],
  "Milonga": [
    "Normal,Normal"
  ],
  "Miniver": [
    "Normal,Normal"
  ],
  "Miriam": [
    "Normal,Normal"
  ],
  "Miriam Fixed": [
    "Normal,Normal"
  ],
  "Miriam Transparent": [
    "Normal,Normal"
  ],
  "Miroslav": [
    "Normal,Normal"
  ],
  "Misconstrued": [
    "Normal,Normal"
  ],
  "Mistral": [
    "Normal,Normal"
  ],
  "Mixed up": [
    "Normal,Normal"
  ],
  "Modern No. 20": [
    "Normal,Normal"
  ],
  "Monsters Attack!": [
    "Normal,Normal"
  ],
  "MoonbeamsHiragana": [
    "Normal,Normal"
  ],
  "MotterFemD": [
    "Normal,Normal"
  ],
  "MS Mincho": [
    "Normal,Normal"
  ],
  "MS Outlook": [
    "Normal,Normal"
  ],
  "MS Reference Sans Serif": [
    "Normal,Normal"
  ],
  "MT Extra": [
    "Normal,Normal"
  ],
  "MV Boli": [
    "Normal,Normal"
  ],
  "Myopia": [
    "Normal,Normal"
  ],
  "NexaHeavy": [
    "Normal,Normal"
  ],
  "NexaRegular": [
    "Normal,Normal"
  ],
  "NexaThin": [
    "Normal,Normal"
  ],
  "Niagara Engraved": [
    "Normal,Normal"
  ],
  "Niagara Solid": [
    "Normal,Normal"
  ],
  "Niconne": [
    "Normal,Normal"
  ],
  "Night Court": [
    "Normal,Normal"
  ],
  "Nilland": [
    "Normal,Normal"
  ],
  "Nine Lives": [
    "Normal,Normal"
  ],
  "NobbiGConDB": [
    "Normal,Normal"
  ],
  "Nocker": [
    "Normal,Normal"
  ],
  "Noel": [
    "Normal,Normal"
  ],
  "Nonstop [italic]": [
    "Normal,Normal"
  ],
  "Notepad": [
    "Normal,Normal"
  ],
  "November": [
    "Normal,Normal"
  ],
  "NudE": [
    "Normal,Normal"
  ],
  "Numskull (BRK)": [
    "Normal,Normal"
  ],
  "nunacom": [
    "Normal,Normal"
  ],
  "NuWave": [
    "Normal,Normal"
  ],
  "RaveParty Hollow": [
    "Normal,Normal"
  ],
  "Ravie": [
    "Normal,Normal"
  ],
  "Real Horror Show": [
    "Normal,Normal"
  ],
  "Redressed": [
    "Normal,Normal"
  ],
  "Regal box": [
    "Normal,Normal"
  ],
  "Regular": [
    "Normal,Normal"
  ],
  "Regulators Condensed": [
    "Normal,Normal"
  ],
  "RemiHead": [
    "Normal,Normal"
  ],
  "ResbalosoSlippingA": [
    "Normal,Normal"
  ],
  "ReskaGraf": [
    "Normal,Normal"
  ],
  "ResPublica": [
    "Normal,Normal"
  ],
  "Reticulum 3": [
    "Normal,Normal"
  ],
  "Retsuc": [
    "Normal,Normal"
  ],
  "Return To Sender": [
    "Normal,Normal"
  ],
  "Revue BT": [
    "Normal,Normal"
  ],
  "Reynard Demo": [
    "Normal,Normal"
  ],
  "Ribeye": [
    "Normal,Normal"
  ],
  "Ridicule": [
    "Normal,Normal"
  ],
  "Righteous": [
    "Normal,Normal"
  ],
  "Riquoth": [
    "Normal,Normal"
  ],
  "Rivalry": [
    "Normal,Normal"
  ],
  "Rivanna": [
    "Normal,Normal"
  ],
  "Road Hoe": [
    "Normal,Normal"
  ],
  "Robokid": [
    "Normal,Normal"
  ],
  "Roboto Condensed": [
    "Normal,Normal"
  ],
  "Rocket Type Condensed": [
    "Normal,Normal"
  ],
  "Rockwell": [
    "Normal,Normal"
  ],
  "ROCKY AOE": [
    "Normal,Normal"
  ],
  "Rod": [
    "Normal,Normal"
  ],
  "Rod Transparent": [
    "Normal,Normal"
  ],
  "Rokford": [
    "Normal,Normal"
  ],
  "RollingStone": [
    "Normal,Normal"
  ],
  "Rose": [
    "Normal,Normal"
  ],
  "Rosegarden": [
    "Normal,Normal"
  ],
  "RoteFlora": [
    "Normal,Normal"
  ],
  "Royal box": [
    "Normal,Normal"
  ],
  "Royal Pain": [
    "Normal,Normal"
  ],
  "RRHeralds": [
    "Normal,Normal"
  ],
  "RubaiyatEngraved": [
    "Normal,Normal"
  ],
  "Ruban Dismoi Tryout": [
    "Normal,Normal"
  ],
  "Rubber Walls": [
    "Normal,Normal"
  ],
  "Rubberneck": [
    "Normal,Normal"
  ],
  "Rundfunk": [
    "Normal,Normal"
  ],
  "Ruthie": [
    "Normal,Normal"
  ],
  "RuttenSpya": [
    "Normal,Normal"
  ],
  "Rye": [
    "Normal,Normal"
  ],
  "Scary Monsters": [
    "Normal,Normal"
  ],
  "Science Project": [
    "Normal,Normal"
  ],
  "Scramble": [
    "Normal,Normal"
  ],
  "screenfox9": [
    "Normal,Normal"
  ],
  "ScrewedSW": [
    "Normal,Normal"
  ],
  "Scriptina": [
    "Normal,Normal"
  ],
  "Scritzy": [
    "Normal,Normal"
  ],
  "Scroll": [
    "Normal,Normal"
  ],
  "Scroonge": [
    "Normal,Normal"
  ],
  "Seeing Stars": [
    "Normal,Normal"
  ],
  "Segoe Print": [
    "Normal,Normal"
  ],
  "SexyMF": [
    "Normal,Normal"
  ],
  "SF Chaerilidae": [
    "Normal,Normal"
  ],
  "SF Comic Script": [
    "Normal,Normal"
  ],
  "SF Eccentric Opus": [
    "Normal,Normal"
  ],
  "SF Theramin Gothic Condensed": [
    "Normal,Normal"
  ],
  "Shoestore": [
    "Normal,Normal"
  ],
  "Shojumaru": [
    "Normal,Normal"
  ],
  "Short Hand": [
    "Normal,Normal"
  ],
  "Shotgun BT": [
    "Normal,Normal"
  ],
  "Showcard Gothic": [
    "Normal,Normal"
  ],
  "Shruti": [
    "Normal,Normal"
  ],
  "SidTheSpider": [
    "Normal,Normal"
  ],
  "Signika": [
    "Normal,Normal"
  ],
  "SILDoulos IPA93": [
    "Normal,Normal"
  ],
  "SimHei": [
    "Normal,Normal"
  ],
  "Simplified Arabic": [
    "Normal,Normal"
  ],
  "Simplified Arabic Fixed": [
    "Normal,Normal"
  ],
  "SinaloaIniD": [
    "Normal,Normal"
  ],
  "SkaterDudes": [
    "Normal,Normal"
  ],
  "Skull Capz (BRK)": [
    "Normal,Normal"
  ],
  "SKULL TS 2": [
    "Normal,Normal"
  ],
  "Smilly": [
    "Normal,Normal"
  ],
  "Smythe": [
    "Normal,Normal"
  ],
  "Snap ITC": [
    "Normal,Normal"
  ],
  "So Extended": [
    "Normal,Normal"
  ],
  "Sofia": [
    "Normal,Normal"
  ],
  "Something Fishy": [
    "Normal,Normal"
  ],
  "Source Sans Pro": [
    "Normal,Normal"
  ],
  "Space Gimboid": [
    "Normal,Normal"
  ],
  "SpeedballNo2SW": [
    "Normal,Normal"
  ],
  "Spit Shine": [
    "Normal,Normal"
  ],
  "SpitCurl": [
    "Normal,Normal"
  ],
  "Stab Wound": [
    "Normal,Normal"
  ],
  "Star Dust Condensed": [
    "Normal,Normal"
  ],
  "Starlight Sans JL": [
    "Normal,Normal"
  ],
  "STCaiyun": [
    "Normal,Normal"
  ],
  "Stencil": [
    "Normal,Normal"
  ],
  "STFangsong": [
    "Normal,Normal"
  ],
  "STHupo": [
    "Normal,Normal"
  ],
  "StickAroundForJoy": [
    "Normal,Normal"
  ],
  "Still Time": [
    "Normal,Normal"
  ],
  "stillframes": [
    "Normal,Normal"
  ],
  "STKaiti": [
    "Normal,Normal"
  ],
  "STLiti": [
    "Normal,Normal"
  ],
  "Stoke": [
    "Normal,Normal"
  ],
  "Stranded (BRK)": [
    "Normal,Normal"
  ],
  "StrokeyBacon": [
    "Normal,Normal"
  ],
  "STSong": [
    "Normal,Normal"
  ],
  "STXihei": [
    "Normal,Normal"
  ],
  "STXingkai": [
    "Normal,Normal"
  ],
  "STXinwei": [
    "Normal,Normal"
  ],
  "STZhongsong": [
    "Normal,Normal"
  ],
  "Subeve": [
    "Normal,Normal"
  ],
  "SuperFrench": [
    "Normal,Normal"
  ],
  "SURROUNDED large": [
    "Normal,Normal"
  ],
  "Swirl": [
    "Normal,Normal"
  ],
  "Swirled (BRK)": [
    "Normal,Normal"
  ],
  "Swiss911 XCm BT": [
    "Normal,Normal"
  ],
  "Switching and Effects": [
    "Normal,Normal"
  ],
  "Swollen": [
    "Normal,Normal"
  ],
  "Sylfaen": [
    "Normal,Normal"
  ],
  "Symbol": [
    "Normal,Normal"
  ],
  "Symbol Set SWA": [
    "Normal,Normal"
  ],
  "Trochut": [
    "Normal,Normal"
  ],
  "Tunga": [
    "Normal,Normal"
  ],
  "Tw Cen MT Condensed": [
    "Normal,Normal"
  ],
  "VTC Letterer Pro": [
    "Normal,Normal"
  ],
  "VTC NightOfTheDeadCorruptCaps": [
    "Normal,Normal"
  ]
};

export const fontLibraryComplete = {
  "Edmunds": [
    "Normal,Normal"
  ],
  "Audiowide": [
    "Normal,Normal"
  ],
  "Drawing Guides": [
    "Normal,Normal"
  ],
  "Raavi": [
    "Normal,Normal"
  ],
  "Myriad Pro": [
    "Bold,Normal"
  ],
  "HelveticaNeueLT Std ExtBlk Cn": [
    "ExtraBlack,Normal"
  ],
  "Lora": [
    "Bold,Normal",
    "Bold,Italic",
    "Normal,Italic",
    "Normal,Normal"
  ],
  "Helvetica-Normal": [
    "Normal,Normal"
  ],
  "HelveticaNeueLT Std Cn": [
    "Normal,Normal",
    "Normal,Oblique"
  ],
  "Guarani_Roman": [
    "Normal,Normal"
  ],
  "Univers 57 Condensed": [
    "Normal,Normal"
  ],
  "Wingdings 2": [
    "Normal,Normal"
  ],
  "ArcherPro Thin": [
    "Thin,Normal",
    "Thin,Italic"
  ],
  "Thai7BangkokSSK": [
    "Normal,Normal"
  ],
  "French Script MT": [
    "Normal,Normal"
  ],
  "Rye": [
    "Normal,Normal"
  ],
  "Niagara Solid": [
    "Normal,Normal"
  ],
  "VA Pe DB": [
    "Normal,Normal"
  ],
  "Menuetto": [
    "Normal,Normal"
  ],
  "Smilly": [
    "Normal,Normal"
  ],
  "MandarinSCD": [
    "Normal,Normal"
  ],
  "Simplified Arabic": [
    "Normal,Normal"
  ],
  "Helvetica35-Thin": [
    "Thin,Normal"
  ],
  "HelveticaRounded-Black": [
    "Black,Italic",
    "Black,Normal"
  ],
  "BeachType": [
    "Normal,Normal"
  ],
  "HelveticaNeue MediumExt": [
    "Medium,Normal",
    "Medium,Oblique",
    "Black,Normal",
    "Black,Oblique"
  ],
  "SF Chrome Fenders Extended": [
    "Normal,Oblique"
  ],
  "Ground Zero": [
    "Normal,Normal"
  ],
  "Brush Script MT": [
    "Normal,Italic"
  ],
  "Y2K Analog Legacy": [
    "Normal,Italic"
  ],
  "HelveticaNeueLT Std UltLt Cn": [
    "ExtraLight,Normal",
    "ExtraLight,Oblique"
  ],
  "Helvetica 25 UltraLight": [
    "ExtraLight,Normal",
    "ExtraLight,Italic"
  ],
  "Nilland-Black": [
    "Black,Normal"
  ],
  "Neil": [
    "Medium,Normal"
  ],
  "Open Sans": [
    "Bold,Normal",
    "Bold,Italic",
    "Normal,Italic",
    "Normal,Normal"
  ],
  "MotterFemD": [
    "Normal,Normal"
  ],
  "Intro ": [
    "Normal,Normal"
  ],
  "Graduate": [
    "Normal,Normal"
  ],
  "KG Ten Thousand Reasons Alt": [
    "Normal,Normal"
  ],
  "Rep": [
    "Medium,Normal"
  ],
  "NimbusSanTLig": [
    "Normal,Italic"
  ],
  "Bookvar": [
    "Bold,Normal",
    "Normal,Italic",
    "Normal,Normal"
  ],
  "Sarpanch ExtraBold": [
    "ExtraBold,Normal"
  ],
  "NexaThin": [
    "Normal,Normal"
  ],
  "Nauvoo": [
    "Normal,Normal"
  ],
  "Intro Book Italic": [
    "Normal,Italic"
  ],
  "Lucida Bright": [
    "SemiBold,Italic",
    "SemiBold,Normal",
    "Normal,Italic",
    "Normal,Normal"
  ],
  "CentraleSansCnd": [
    "Bold,Normal"
  ],
  "RoundestLH": [
    "Normal,Italic"
  ],
  "TANTOR": [
    "Normal,Normal"
  ],
  "voxBOX": [
    "Normal,Normal"
  ],
  "Simplified Arabic Fixed": [
    "Normal,Normal"
  ],
  "Intramural JL": [
    "Normal,Normal"
  ],
  "Milkfresh": [
    "Normal,Normal"
  ],
  "Bitter": [
    "Bold,Normal",
    "Normal,Italic",
    "Normal,Normal"
  ],
  "Nexa-Light-Italic": [
    "Light,Italic"
  ],
  "HarlowD": [
    "Normal,Normal"
  ],
  "France": [
    "Normal,Normal"
  ],
  "NuWave": [
    "Normal,Normal"
  ],
  "SF Chaerilidae": [
    "Normal,Normal"
  ],
  "Nexa Rust Sans Black Shadow 01": [
    "Black,Normal"
  ],
  "Archer Semibold": [
    "SemiBold,Normal",
    "SemiBold,Italic"
  ],
  "Jamiro": [
    "Normal,Normal"
  ],
  "Segoe Print": [
    "Bold,Normal",
    "Normal,Normal"
  ],
  "Kid Kosmic": [
    "Normal,Italic"
  ],
  "Meddon": [
    "Normal,Normal"
  ],
  "SF Theramin Gothic Condensed": [
    "Normal,Normal"
  ],
  "W.J. Pearce hollow": [
    "Normal,Normal"
  ],
  "Swirl": [
    "Normal,Normal"
  ],
  "MV Boli": [
    "Normal,Normal"
  ],
  "Xacto Blade": [
    "Normal,Normal"
  ],
  "STCaiyun": [
    "Normal,Normal"
  ],
  "Ruthie": [
    "Normal,Normal"
  ],
  "Open Sans Light": [
    "Light,Normal",
    "Light,Italic"
  ],
  "Code Pro Black LC": [
    "Black,Normal"
  ],
  "Offside": [
    "Normal,Normal"
  ],
  "Pussycat": [
    "Normal,Normal"
  ],
  "Sorawin": [
    "Medium,Normal"
  ],
  "Bebas Neue Bold": [
    "Bold,Normal"
  ],
  "HelveticaNeueLT Std Lt Cn": [
    "Light,Normal",
    "Light,Oblique"
  ],
  "Jerkoff": [
    "Normal,Normal"
  ],
  "Nexa-Light": [
    "Light,Normal"
  ],
  "Maiandra GD": [
    "Normal,Normal"
  ],
  "Dorsa": [
    "Normal,Normal"
  ],
  "Helvetica Black Hollow": [
    "Black,Italic"
  ],
  "HelveticaRounded LT Std Blk": [
    "Black,Normal",
    "Black,Oblique"
  ],
  "Sofia": [
    "Normal,Normal"
  ],
  "GF Ordner Normal": [
    "Normal,Normal"
  ],
  "Intro Light Italic": [
    "Light,Italic"
  ],
  "MS Reference Sans Serif": [
    "Normal,Normal"
  ],
  "Shojumaru": [
    "Normal,Normal"
  ],
  "NuevoLitho": [
    "Light,Italic"
  ],
  "Helvetica Extra Compressed": [
    "Medium,Normal"
  ],
  "Re-buried": [
    "Normal,Normal"
  ],
  "Acme": [
    "Normal,Normal"
  ],
  "Lucida Console": [
    "Normal,Normal"
  ],
  "Basic": [
    "Normal,Normal"
  ],
  "IkonWrite": [
    "Normal,Normal"
  ],
  "GhostBayou": [
    "Normal,Normal"
  ],
  "ResbalosoSlippingA": [
    "Normal,Normal"
  ],
  "HanWangFangSongMedium": [
    "Normal,Normal"
  ],
  "FZ JAZZY 12 CRACKED": [
    "Normal,Normal"
  ],
  "Helvetica85-Heavy": [
    "Black,Normal"
  ],
  "Rambo Killer ": [
    "Normal,Normal"
  ],
  "Aboriginal Sans": [
    "Bold,Normal",
    "Bold,Italic",
    "Normal,Italic",
    "Normal,Normal"
  ],
  "Taskeksem inflamerat": [
    "Normal,Normal"
  ],
  "Nexa Rust Script B 00": [
    "Bold,Normal"
  ],
  "ScrewedSW": [
    "Normal,Normal"
  ],
  "CHICASyMUJERES": [
    "Normal,Normal"
  ],
  "Subeve": [
    "Normal,Normal"
  ],
  "Courgette": [
    "Normal,Normal"
  ],
  "Alice": [
    "Normal,Normal"
  ],
  "Roboto Medium": [
    "Medium,Normal",
    "Medium,Italic"
  ],
  "Chow Fun": [
    "Normal,Normal"
  ],
  "Nonstop [italic]": [
    "Normal,Normal"
  ],
  "Cooper Black": [
    "Black,Normal"
  ],
  "Split splat splodge": [
    "Bold,Normal"
  ],
  "STKaiti": [
    "Normal,Normal"
  ],
  "Chalk-hand-lettering-shaded_dem": [
    "Normal,Normal"
  ],
  "Vipnagorgialla": [
    "Normal,Normal"
  ],
  "Machine-gun": [
    "Normal,Normal"
  ],
  "Raketta From Mars": [
    "Normal,Normal"
  ],
  "Humeur": [
    "Normal,Normal"
  ],
  "Xenowort": [
    "Normal,Normal"
  ],
  "Code Pro Bold LC": [
    "Bold,Normal"
  ],
  "Nouveau": [
    "Medium,Italic"
  ],
  "Arabic Transparent": [
    "Bold,Normal",
    "Normal,Normal"
  ],
  "Qurve Wide": [
    "Normal,Italic"
  ],
  "Julee": [
    "Normal,Normal"
  ],
  "BaltOptima": [
    "Normal,Normal"
  ],
  "HelveticaNeueLT Std UltLt": [
    "ExtraLight,Normal"
  ],
  "Under attack skew": [
    "Normal,Normal"
  ],
  "Kristen ITC": [
    "Normal,Normal"
  ],
  "Source Sans Pro Semibold": [
    "SemiBold,Normal"
  ],
  "Ultra": [
    "Normal,Normal"
  ],
  "Comic Sans MS": [
    "Normal,Normal"
  ],
  "Patriot": [
    "Normal,Normal"
  ],
  "Splendid 66": [
    "Thin,Normal"
  ],
  "Quicksand": [
    "Bold,Normal",
    "Bold,Italic",
    "Normal,Italic",
    "ExtraLight,Normal",
    "ExtraLight,Italic",
    "Normal,Normal"
  ],
  "Intro Book Caps": [
    "Normal,Normal"
  ],
  "HelveticaExtO 3": [
    "Normal,Normal"
  ],
  "Pigiarniq": [
    "Bold,Normal",
    "Normal,Italic",
    "Normal,Normal"
  ],
  "Fondamento": [
    "Normal,Italic",
    "Normal,Normal"
  ],
  "naked monk": [
    "Normal,Normal"
  ],
  "Qurve Hollow": [
    "Normal,Italic"
  ],
  "QTKung-Fu": [
    "Medium,Normal"
  ],
  "y.n.w.u.a.y": [
    "Normal,Normal"
  ],
  "DK Crayon Crumble": [
    "Normal,Normal"
  ],
  "Cordia New": [
    "Normal,Normal"
  ],
  "Elsie Black": [
    "Black,Normal"
  ],
  "Verticalization": [
    "Normal,Normal"
  ],
  "Zamané e Euransi i Nauromenis ": [
    "Normal,Normal"
  ],
  "Baumans": [
    "Normal,Normal"
  ],
  "Helvetica37-CondensedThin": [
    "Thin,Normal"
  ],
  "Archer Extra Light": [
    "ExtraLight,Normal",
    "ExtraLight,Italic"
  ],
  "Handlee": [
    "Normal,Normal"
  ],
  "Rogue Hero Laser": [
    "Normal,Normal"
  ],
  "Rainy Days": [
    "Normal,Normal"
  ],
  "Chewy": [
    "Normal,Normal"
  ],
  "Californian FB": [
    "Bold,Normal",
    "Normal,Italic",
    "Normal,Normal"
  ],
  "Intro Light": [
    "Light,Normal"
  ],
  "EucrosiaUPC": [
    "Bold,Normal",
    "Bold,Italic",
    "Normal,Italic",
    "Normal,Normal"
  ],
  "Zymbols": [
    "Normal,Normal"
  ],
  "Relief": [
    "Medium,Normal"
  ],
  "Bernard MT Condensed": [
    "Normal,Normal"
  ],
  "UNCONFORM": [
    "Normal,Normal"
  ],
  "Rockwell Std": [
    "Bold,Normal"
  ],
  "Helvetica Ultra Compressed": [
    "Medium,Normal"
  ],
  "Karloff": [
    "Medium,Normal"
  ],
  "Aclonica": [
    "Normal,Normal"
  ],
  "RobleRoundedSCapsSSK": [
    "Normal,Italic"
  ],
  "Nexa-Black-Italic": [
    "Black,Italic"
  ],
  "Redressed": [
    "Normal,Normal"
  ],
  "Archer Hairline": [
    "250,Normal",
    "250,Italic"
  ],
  "Quinquefoliolate": [
    "Normal,Normal"
  ],
  "Return To Sender": [
    "Normal,Normal"
  ],
  "Core Sans A 65 Bold": [
    "Bold,Italic",
    "Bold,Normal"
  ],
  "Sam is my Name": [
    "Normal,Normal"
  ],
  "ABeeZee": [
    "Normal,Italic",
    "Normal,Normal"
  ],
  "Bulgarian Courier": [
    "Thin,Normal"
  ],
  "Intro Thin Caps": [
    "Thin,Normal"
  ],
  "Sci Fied 2002 Ultra": [
    "ExtraBold,Normal"
  ],
  "Odd Dog": [
    "Normal,Normal"
  ],
  "Berlin Sans FB": [
    "Normal,Normal"
  ],
  "Macaroni": [
    "Normal,Normal"
  ],
  "Helvetica Rounded LT": [
    "Bold,Normal"
  ],
  "Verdana": [
    "Normal,Normal"
  ],
  "Xmas 97": [
    "Normal,Normal"
  ],
  "Judge": [
    "Normal,Normal"
  ],
  "Dead World": [
    "Normal,Normal"
  ],
  "Kohinoor Bangla": [
    "SemiBold,Normal",
    "Normal,Normal",
    "Bold,Normal",
    "Light,Normal",
    "Medium,Normal"
  ],
  "YrBkMess": [
    "Normal,Normal"
  ],
  "Archer Bold": [
    "Bold,Normal",
    "Bold,Italic"
  ],
  "JackRoman": [
    "Normal,Normal"
  ],
  "Informal Roman": [
    "Normal,Normal"
  ],
  "Rundfunk": [
    "Normal,Normal"
  ],
  "ER Third Roman KOI-8": [
    "Normal,Normal"
  ],
  "Geometr415 Md BT": [
    "Normal,Italic"
  ],
  "Baskerville Old Face": [
    "Normal,Normal"
  ],
  "HelveticaNeue UltraLigExt": [
    "ExtraLight,Normal",
    "ExtraLight,Oblique"
  ],
  "HanWangYenLight": [
    "Normal,Normal"
  ],
  "JackCondensed": [
    "Normal,Normal"
  ],
  "Rocket Type Condensed": [
    "Normal,Normal"
  ],
  "HanWangMingLight": [
    "Normal,Normal"
  ],
  "Helvetica Condensed BQ 2": [
    "Bold,Normal"
  ],
  "Impossibilium (BRK)": [
    "Normal,Normal"
  ],
  "VPS Can Tho Hoa": [
    "Normal,Normal"
  ],
  "KabanaBold": [
    "Normal,Normal"
  ],
  "Papyrus": [
    "Normal,Normal"
  ],
  "Intro Cond Caps SemBd": [
    "SemiBold,Normal"
  ],
  "JaggaPoint": [
    "Normal,Normal"
  ],
  "Broadway": [
    "Normal,Normal"
  ],
  "Arial Ykt": [
    "Normal,Normal"
  ],
  "Logan": [
    "Medium,Normal"
  ],
  "HanWangMingMediumChuIn": [
    "Normal,Normal"
  ],
  "Nexa-Regular-Italic": [
    "Normal,Italic"
  ],
  "Flower Ornaments": [
    "Normal,Normal"
  ],
  "Code Pro LC": [
    "Normal,Normal"
  ],
  "Ubuntu Mono": [
    "Bold,Normal",
    "Bold,Italic",
    "Normal,Normal",
    "Normal,Italic"
  ],
  "Tangerine": [
    "Bold,Normal",
    "Normal,Normal"
  ],
  "HelveticaNeueLT Std Blk Ext": [
    "Black,Normal",
    "Black,Oblique"
  ],
  "SexyMF": [
    "Normal,Normal"
  ],
  "Many moods of Moe": [
    "Normal,Normal"
  ],
  "Faktos-Mirror": [
    "Normal,Normal"
  ],
  "Intro Cond Caps 2": [
    "Bold,Normal",
    "Normal,Normal"
  ],
  "Proxima Nova Rg": [
    "Bold,Normal",
    "Bold,Italic",
    "Normal,Normal",
    "Normal,Italic"
  ],
  "Ruban Dismoi Tryout": [
    "Normal,Normal"
  ],
  "Anhedonia": [
    "Normal,Normal"
  ],
  "Nexa-Bold-Italic": [
    "Bold,Italic"
  ],
  "Intro Regular Alt": [
    "Normal,Normal"
  ],
  "Miroslav": [
    "Normal,Normal"
  ],
  "Croat": [
    "Normal,Normal"
  ],
  "BrowalliaUPC": [
    "Normal,Normal",
    "Bold,Normal",
    "Normal,Italic",
    "Bold,Italic"
  ],
  "Pacifico": [
    "Normal,Normal"
  ],
  "Sad Jane": [
    "Normal,Normal"
  ],
  "Insane Hours": [
    "Normal,Normal"
  ],
  "Chey 1 SILManuscriptL": [
    "Normal,Normal"
  ],
  "Wide Latin": [
    "Normal,Normal"
  ],
  "Lowtech": [
    "Normal,Normal"
  ],
  "HelveticaRounded": [
    "Bold,Italic",
    "Bold,Normal"
  ],
  "Helvetica LT Std Cond": [
    "Bold,Normal",
    "Bold,Oblique",
    "Normal,Normal",
    "Normal,Oblique"
  ],
  "Onyx": [
    "Normal,Normal"
  ],
  "Reticulum 3": [
    "Normal,Normal"
  ],
  "Signika": [
    "Bold,Normal",
    "Light,Normal",
    "Normal,Normal",
    "SemiBold,Normal"
  ],
  "Sand": [
    "Normal,Normal"
  ],
  "Helvetica87-CondensedHeavy": [
    "Black,Normal"
  ],
  "SkaterDudes": [
    "Normal,Normal"
  ],
  "Cheetah": [
    "Normal,Normal"
  ],
  "SF Eccentric Opus": [
    "Normal,Normal"
  ],
  "Pigiarniq Heavy": [
    "Black,Normal"
  ],
  "ArcherPro Book": [
    "Light,Normal",
    "Light,Italic"
  ],
  "Helvetica BQ": [
    "Medium,Normal",
    "Medium,Italic"
  ],
  "Intro Inline": [
    "Normal,Normal"
  ],
  "Zhang QA": [
    "Normal,Normal"
  ],
  "Eras Demi ITC": [
    "SemiBold,Normal"
  ],
  "ArcherPro Light": [
    "Light,Normal",
    "Light,Italic"
  ],
  "SandCastles": [
    "Normal,Normal"
  ],
  "Intro Black Inline": [
    "Black,Normal"
  ],
  "Helvetica Neue Med": [
    "Medium,Normal",
    "Medium,Italic"
  ],
  "Tannenberg Fett": [
    "Normal,Normal"
  ],
  "Hollywood": [
    "Normal,Normal"
  ],
  "Nexa Slab Thin Oblique": [
    "Thin,Oblique"
  ],
  "Gautami": [
    "Normal,Normal"
  ],
  "Proxima Nova Th": [
    "ExtraBold,Normal"
  ],
  "Jeff-Chris": [
    "SemiBold,Normal"
  ],
  "Sakkal Majalla": [
    "Normal,Normal",
    "Bold,Normal"
  ],
  "Helvetica Condensed": [
    "Bold,Normal",
    "Medium,Oblique",
    "Medium,Normal"
  ],
  "CrimeFighter BB": [
    "Bold,Normal",
    "Normal,Normal"
  ],
  "Helvetica CE": [
    "Bold,Normal",
    "Bold,Oblique",
    "Normal,Oblique",
    "Normal,Normal"
  ],
  "Intro Cond Caps": [
    "Light,Normal",
    "Thin,Normal"
  ],
  "Helvetica Condensed BQ": [
    "Light,Normal",
    "Light,Italic",
    "Medium,Normal"
  ],
  "HelveticaNeueLT Std Bold Outln": [
    "Bold,Normal"
  ],
  "Mexacali": [
    "Normal,Normal"
  ],
  "Microsoft Sans Serif": [
    "Normal,Normal"
  ],
  "Helvetica95-Black": [
    "Black,Normal"
  ],
  "Griffy": [
    "Normal,Normal"
  ],
  "Lewis F. Day 191": [
    "Normal,Normal"
  ],
  "Joint": [
    "Normal,Normal"
  ],
  "SinaloaIniD": [
    "Normal,Normal"
  ],
  "Copperplate Gothic Light": [
    "Light,Normal"
  ],
  "AWSiamEnglishnotThai": [
    "Medium,Normal"
  ],
  "Source Sans Pro": [
    "Bold,Normal",
    "Normal,Normal"
  ],
  "Nexa Slab xBold Oblique": [
    "ExtraBold,Oblique"
  ],
  "Rudiment": [
    "Medium,Normal"
  ],
  "Samson Light Oblique": [
    "Light,Oblique"
  ],
  "Groovalicious Tweak": [
    "Normal,Normal"
  ],
  "Nife Fiter": [
    "Normal,Normal"
  ],
  "Alice0 Lao": [
    "Normal,Normal"
  ],
  "Helvetica Cyrillic A Upright": [
    "Medium,Normal"
  ],
  "Astloch": [
    "Bold,Normal",
    "Normal,Normal"
  ],
  "Backslide": [
    "Bold,Normal"
  ],
  "VPS Quang Duc": [
    "Normal,Italic"
  ],
  "Raveflire 2.0": [
    "Normal,Normal"
  ],
  "Qurve": [
    "Normal,Normal"
  ],
  "HelveticaNeueLT Std Med Ext": [
    "Medium,Normal",
    "Medium,Oblique"
  ],
  "HelveticaNeue Extended": [
    "Normal,Normal",
    "Normal,Oblique"
  ],
  "Open Sans Semibold": [
    "SemiBold,Normal",
    "SemiBold,Italic"
  ],
  "Zinc Boomerang": [
    "Normal,Normal"
  ],
  "pills are good": [
    "Normal,Normal"
  ],
  "Electric Pickle": [
    "Normal,Normal"
  ],
  "Notation Heavy JL": [
    "Black,Normal"
  ],
  "Rod": [
    "Normal,Normal"
  ],
  "Bilbo": [
    "Normal,Normal"
  ],
  "Vollkorn Bold Italic": [
    "Bold,Italic"
  ],
  "Ukrainian?Izhitsa": [
    "Normal,Normal"
  ],
  "Helvetica LT Std Light": [
    "Light,Normal",
    "Light,Oblique"
  ],
  "Yanone Kaffeesatz Light": [
    "Light,Normal"
  ],
  "Inconsolata": [
    "Bold,Normal",
    "Normal,Normal"
  ],
  "Helvetica-Light-Light-Italic": [
    "Light,Italic"
  ],
  "Wingdings 3": [
    "Normal,Normal"
  ],
  "Tw Cen MT Condensed": [
    "Bold,Normal",
    "Normal,Normal"
  ],
  "Tangerine XCn": [
    "Normal,Normal"
  ],
  "Symbol": [
    "Normal,Normal"
  ],
  "Hallandale Deco Bd It. Smc JL": [
    "Normal,Normal"
  ],
  "Chango": [
    "Normal,Normal"
  ],
  "Eras Bold ITC": [
    "Bold,Normal"
  ],
  "Goudy Old Style": [
    "Normal,Normal",
    "Bold,Normal",
    "Normal,Italic"
  ],
  "Zone23_Dreamtime 923": [
    "Normal,Normal"
  ],
  "Gill Sans MT Ext Condensed Bold": [
    "Bold,Normal"
  ],
  "Irmologion": [
    "Normal,Normal"
  ],
  "RomanCyrillic Std": [
    "Normal,Normal"
  ],
  "Albanian": [
    "Normal,Normal"
  ],
  "M": [
    "Medium,Normal"
  ],
  "EraserDust": [
    "Normal,Normal"
  ],
  "u27fog": [
    "Normal,Normal"
  ],
  "Nexa-XBold-Italic": [
    "Normal,Italic"
  ],
  "VIPER NORA": [
    "Normal,Normal"
  ],
  "Lucida Sans Unicode": [
    "Normal,Normal"
  ],
  "NimbusSanPCon": [
    "Normal,Italic"
  ],
  "Marlo": [
    "Normal,Normal"
  ],
  "HelveticaObl-He": [
    "Normal,Normal"
  ],
  "KabanaBook": [
    "Normal,Normal"
  ],
  "Nebullium": [
    "Normal,Normal"
  ],
  "Umbles": [
    "Normal,Normal"
  ],
  "Mikey Jax": [
    "Normal,Normal"
  ],
  "Kunstler Script": [
    "Normal,Normal"
  ],
  "Limelight": [
    "Normal,Normal"
  ],
  "Solomon": [
    "Bold,Normal"
  ],
  "Nilland-SmallCaps": [
    "Bold,Normal",
    "Normal,Normal"
  ],
  "Scroonge": [
    "Normal,Normal"
  ],
  "Akronim": [
    "Normal,Normal"
  ],
  "DK Cool Crayon": [
    "Normal,Normal"
  ],
  "Gloucester MT Extra Condensed": [
    "Normal,Normal"
  ],
  "TradeGothic": [
    "Bold,Italic"
  ],
  "Rockwell": [
    "Normal,Normal",
    "Bold,Normal",
    "Bold,Italic",
    "Normal,Italic"
  ],
  "VTC NightOfTheDeadCorruptCaps": [
    "Normal,Normal"
  ],
  "Footlight MT Light": [
    "Light,Normal"
  ],
  "Intro Cond Light Free": [
    "Light,Normal"
  ],
  "Marfhaus": [
    "Normal,Normal"
  ],
  "Halqemeylem Serif": [
    "Bold,Normal"
  ],
  "Jokerman": [
    "Normal,Normal"
  ],
  "Mangal": [
    "Normal,Normal"
  ],
  "BaltFrutiger": [
    "Light,Normal"
  ],
  "NEOLITH": [
    "Normal,Normal"
  ],
  "Bebas Neue Regular": [
    "Normal,Normal"
  ],
  "Rancho": [
    "Normal,Normal"
  ],
  "ArabicKufiSSK": [
    "Normal,Normal"
  ],
  "Piedra": [
    "Normal,Normal"
  ],
  "Helvetica53-Extended": [
    "Normal,Normal"
  ],
  "Edwardian Script ITC": [
    "Normal,Normal"
  ],
  "November": [
    "Normal,Normal"
  ],
  "Helvetica-Conth": [
    "Medium,Normal"
  ],
  "DFKai-SB": [
    "Normal,Normal"
  ],
  "Roboto Thin": [
    "250,Normal",
    "250,Italic"
  ],
  "Swiss911 XCm BT": [
    "Normal,Normal"
  ],
  "HelveticaNeue BlackCond": [
    "Black,Normal",
    "Black,Oblique"
  ],
  "Helvetica-Condensed-Light-Li": [
    "Light,Normal"
  ],
  "Lobster": [
    "Normal,Normal"
  ],
  "Timok": [
    "Normal,Italic"
  ],
  "Myriad Web Pro": [
    "Bold,Normal",
    "Normal,Italic",
    "Normal,Normal"
  ],
  "Sarpanch": [
    "Normal,Normal"
  ],
  "HelveticaExt-No": [
    "Normal,Normal"
  ],
  "Rubberneck": [
    "Normal,Normal"
  ],
  "Nexa Slab Black Oblique": [
    "Black,Italic"
  ],
  "AntoniousOL": [
    "Normal,Normal"
  ],
  "HanWangHeiHeavy": [
    "Normal,Normal"
  ],
  "Intro Book Alt": [
    "Normal,Normal"
  ],
  "Forte": [
    "Normal,Normal"
  ],
  "Switching and Effects": [
    "Normal,Normal"
  ],
  "Constantia": [
    "Normal,Normal",
    "Bold,Normal",
    "Normal,Italic",
    "Bold,Italic"
  ],
  "Abel": [
    "Normal,Normal"
  ],
  "Dutch823 BT": [
    "Normal,Normal"
  ],
  "Wellfleet": [
    "Normal,Normal"
  ],
  "Warp 1": [
    "Normal,Normal"
  ],
  "Marathon II": [
    "Normal,Normal"
  ],
  "Pigiarniq Light": [
    "Light,Normal"
  ],
  "VTC Lo-Down": [
    "Normal,Normal"
  ],
  "Bebas Neue Thin": [
    "ExtraLight,Normal"
  ],
  "Omicron Zeta Slant": [
    "Normal,Normal"
  ],
  "Code Light": [
    "Light,Normal"
  ],
  "HanWangYanKai": [
    "Normal,Normal"
  ],
  "Lancelot": [
    "Normal,Normal"
  ],
  "Takeout": [
    "Normal,Normal"
  ],
  "ReskaGraf": [
    "Normal,Normal"
  ],
  "Righteous": [
    "Normal,Normal"
  ],
  "Rose": [
    "Normal,Normal"
  ],
  "Miriam Fixed": [
    "Normal,Normal"
  ],
  "Shruti": [
    "Normal,Normal"
  ],
  "Year supply of fairy cakes": [
    "Normal,Normal"
  ],
  "Random Voter": [
    "Normal,Normal"
  ],
  "RobinsHand": [
    "Medium,Normal"
  ],
  "Love Letters": [
    "Normal,Normal"
  ],
  "HelveticaObl-Th": [
    "Normal,Normal"
  ],
  "RANXEROX": [
    "Normal,Normal"
  ],
  "Native Alien Extended": [
    "Normal,Normal"
  ],
  "Merriweather": [
    "Black,Normal",
    "Bold,Normal",
    "Bold,Italic",
    "Black,Italic",
    "Normal,Italic",
    "250,Normal",
    "Light,Italic",
    "Normal,Normal"
  ],
  "Night Court": [
    "Normal,Normal"
  ],
  "Intro Bold Caps": [
    "Bold,Normal"
  ],
  "Wingdings": [
    "Normal,Normal"
  ],
  "Code Pro Light": [
    "Light,Normal"
  ],
  "KodchiangUPC": [
    "Bold,Normal",
    "Bold,Italic",
    "Normal,Italic",
    "Normal,Normal"
  ],
  "Intro Black Alt": [
    "Black,Normal"
  ],
  "Devonshire": [
    "Normal,Normal"
  ],
  "Oakland": [
    "Medium,Normal"
  ],
  "Montserrat": [
    "Black,Normal",
    "Bold,Normal",
    "Normal,Normal",
    "250,Normal"
  ],
  "LetterGotLBol": [
    "Normal,Normal"
  ],
  "Helvetica LT Std Fractions": [
    "Normal,Normal",
    "Bold,Normal"
  ],
  "Space Gimboid": [
    "Normal,Normal"
  ],
  "Core Sans A 35 Light": [
    "Light,Italic",
    "Light,Normal"
  ],
  "Justinian": [
    "Normal,Normal"
  ],
  "Bodoni MT Condensed": [
    "Bold,Normal",
    "Bold,Italic",
    "Normal,Italic",
    "Normal,Normal"
  ],
  "So Extended": [
    "Normal,Normal"
  ],
  "Revel": [
    "Medium,Normal"
  ],
  "Zachary Hanson": [
    "Normal,Normal"
  ],
  "Sail": [
    "Normal,Normal"
  ],
  "Office": [
    "Normal,Normal"
  ],
  "Star Dust Condensed": [
    "Normal,Normal"
  ],
  "Regulators Condensed": [
    "Normal,Normal"
  ],
  "Elephant": [
    "Normal,Normal",
    "Normal,Italic"
  ],
  "GENUINE": [
    "Normal,Normal"
  ],
  "Stiletto": [
    "Black,Normal"
  ],
  "Kenia": [
    "Normal,Normal"
  ],
  "LeedsCyr Koi8_5": [
    "Normal,Normal"
  ],
  "Arabic Typesetting": [
    "Normal,Normal"
  ],
  "Matura MT Script Capitals": [
    "Normal,Normal"
  ],
  "Roboto": [
    "Bold,Normal",
    "Bold,Italic",
    "Normal,Italic",
    "Normal,Normal"
  ],
  "Kavoon": [
    "Normal,Normal"
  ],
  "HelveticaRounded LT Std Bd": [
    "Bold,Normal",
    "Bold,Oblique"
  ],
  "Univers": [
    "Bold,Normal"
  ],
  "KidTYPEPaint": [
    "Normal,Normal"
  ],
  "Nexa Rust Sans Black Shadow": [
    "Black,Normal"
  ],
  "Roboto Condensed": [
    "Bold,Normal",
    "Bold,Italic",
    "Normal,Italic",
    "Normal,Normal"
  ],
  "Centaur": [
    "Normal,Normal"
  ],
  "Luxo": [
    "Normal,Normal"
  ],
  "Helvetica": [
    "Bold,Normal",
    "Medium,Oblique",
    "Medium,Normal",
    "Bold,Oblique"
  ],
  "HelveticaRounded LT Std BdCn": [
    "Bold,Normal",
    "Bold,Oblique"
  ],
  "Snap ITC": [
    "Normal,Normal"
  ],
  "samarin": [
    "Normal,Normal"
  ],
  "Yellowjacket Rotate": [
    "Normal,Normal"
  ],
  "HelveticaNeueLT Std Ext": [
    "Normal,Normal",
    "Normal,Oblique"
  ],
  "Helvetica Fractions": [
    "Medium,Normal",
    "Bold,Normal",
    "Normal,Normal"
  ],
  "Combo": [
    "Normal,Normal"
  ],
  "FrankRuehl": [
    "Normal,Normal"
  ],
  "Arvo": [
    "Bold,Normal",
    "Bold,Italic",
    "Normal,Italic",
    "Normal,Normal"
  ],
  "Gilgongo Doro": [
    "Normal,Normal"
  ],
  "Eight Track program 3": [
    "Normal,Normal"
  ],
  "Temps Euro-Catalan": [
    "Normal,Normal"
  ],
  "HanWangHeiLight": [
    "Normal,Normal"
  ],
  "Robokid": [
    "Normal,Normal"
  ],
  "Deftone Stylus": [
    "Normal,Normal"
  ],
  "Franklin Gothic Demi": [
    "SemiBold,Normal",
    "SemiBold,Italic"
  ],
  "Salter": [
    "Medium,Normal"
  ],
  "Helvetica CE Narrow": [
    "Normal,Normal",
    "Bold,Normal",
    "Bold,Oblique",
    "Normal,Oblique"
  ],
  "Rogue Hero Condensed": [
    "Normal,Normal"
  ],
  "Chupada Thin": [
    "250,Italic",
    "250,Normal"
  ],
  "VPS Tuyen Duc": [
    "Normal,Normal"
  ],
  "HelveticaRounded-Condensed": [
    "Bold,Normal"
  ],
  "Unkempt": [
    "Bold,Normal",
    "Normal,Normal"
  ],
  "Rivalry": [
    "Normal,Normal"
  ],
  "Blade Runner Movie Font": [
    "Bold,Italic"
  ],
  "Intro Light Alt": [
    "Light,Normal"
  ],
  "Bodoni MT Black": [
    "Black,Italic",
    "Black,Normal"
  ],
  "Harrington": [
    "Normal,Normal"
  ],
  "Greek": [
    "Normal,Normal"
  ],
  "Tattoo No1": [
    "Normal,Normal"
  ],
  "Garamond": [
    "Normal,Normal",
    "Bold,Normal",
    "Normal,Italic"
  ],
  "SpitCurl": [
    "Normal,Normal"
  ],
  "Hacknslash": [
    "Normal,Normal"
  ],
  "Butterflies": [
    "Normal,Normal"
  ],
  "Vollkorn Bold": [
    "Bold,Normal"
  ],
  "Raleway": [
    "Black,Normal",
    "Black,Italic",
    "Bold,Normal",
    "Bold,Italic",
    "ExtraBold,Normal",
    "ExtraBold,Italic",
    "ExtraLight,Normal",
    "250,Italic",
    "Normal,Italic",
    "Light,Normal",
    "Light,Italic",
    "Medium,Normal",
    "Medium,Italic",
    "Normal,Normal",
    "SemiBold,Normal",
    "SemiBold,Italic",
    "Thin,Normal"
  ],
  "BaltHelvetica": [
    "Normal,Normal"
  ],
  "Fat": [
    "Normal,Normal"
  ],
  "Warlords": [
    "SemiBold,Normal"
  ],
  "Samba is Dead": [
    "Normal,Normal"
  ],
  "After Shok": [
    "Normal,Normal"
  ],
  "Miriam Transparent": [
    "Normal,Normal"
  ],
  "Fatty": [
    "Normal,Normal"
  ],
  "Ruach LET": [
    "Medium,Normal"
  ],
  "HelveticaNeue UltraLigCond": [
    "ExtraLight,Normal",
    "ExtraLight,Oblique"
  ],
  "Helvetica Neue LT Med": [
    "Medium,Normal"
  ],
  "Nilland": [
    "Bold,Normal",
    "Normal,Normal"
  ],
  "OCR-A BT": [
    "Normal,Normal"
  ],
  "Marquee Moon": [
    "Normal,Normal"
  ],
  "Noel": [
    "Normal,Normal"
  ],
  "Vivaldi": [
    "Normal,Italic"
  ],
  "JustSmashing": [
    "Normal,Normal"
  ],
  "Archer Book": [
    "325,Normal",
    "325,Italic"
  ],
  "Tempus Sans ITC": [
    "Normal,Normal"
  ],
  "Birds of a Feather": [
    "Normal,Normal"
  ],
  "Curlz MT": [
    "Normal,Normal"
  ],
  "Raleigh Md BT": [
    "Normal,Normal"
  ],
  "Luftwaffe": [
    "Medium,Normal"
  ],
  "HelveticaNeueLT Std Thin Ext": [
    "Thin,Normal",
    "Thin,Oblique"
  ],
  "Occasion DB": [
    "Normal,Normal"
  ],
  "Yesterday DB": [
    "Normal,Normal"
  ],
  "Japanese": [
    "Normal,Normal"
  ],
  "Qurve Thin": [
    "Thin,Italic"
  ],
  "Intro Cond 2": [
    "Bold,Normal",
    "Bold,Italic",
    "Normal,Italic",
    "Normal,Normal"
  ],
  "Vollkorn Regular": [
    "Normal,Normal"
  ],
  "Core Sans A 15 Thin": [
    "Thin,Italic",
    "Thin,Normal"
  ],
  "OCEAN": [
    "Medium,Normal"
  ],
  "Doulos SIL": [
    "Normal,Normal"
  ],
  "Faktosas-Slanted": [
    "Normal,Oblique"
  ],
  "Nexa Slab Heavy Italic": [
    "Black,Italic"
  ],
  "Cree": [
    "Normal,Normal"
  ],
  "Greek Becker": [
    "Normal,Normal"
  ],
  "IcedEarth": [
    "Normal,Normal"
  ],
  "HelveticaNeue BlackExt": [
    "Black,Normal",
    "Black,Oblique"
  ],
  "Molle": [
    "Normal,Italic"
  ],
  "Ronda": [
    "Normal,Italic"
  ],
  "Nexa Slab Light Oblique": [
    "Light,Oblique"
  ],
  "Linoleum": [
    "Normal,Normal"
  ],
  "Xephyr Italic": [
    "Normal,Italic"
  ],
  "Hall Fetica": [
    "Normal,Normal"
  ],
  "HelveticaNeueLT Std": [
    "Normal,Normal"
  ],
  "Juice ITC": [
    "Normal,Normal"
  ],
  "Y2K Neophyte": [
    "Normal,Italic"
  ],
  "STXingkai": [
    "Normal,Normal"
  ],
  "Koffee": [
    "Medium,Normal"
  ],
  "Nexa-XBold": [
    "Normal,Normal"
  ],
  "HelveticaNeueLT Std Extended": [
    "Bold,Normal",
    "Bold,Oblique"
  ],
  "Bodoni MT Poster Compressed": [
    "Light,Normal"
  ],
  "Reactivare": [
    "Normal,Normal"
  ],
  "Nexa Slab Regular": [
    "Normal,Normal"
  ],
  "Helvetica Neue": [
    "Black,Italic",
    "Medium,Italic",
    "Medium,Normal",
    "Light,Normal",
    "Light,Italic",
    "Thin,Normal",
    "Thin,Italic"
  ],
  "Stab Wound": [
    "Normal,Normal"
  ],
  "Nexa-Book-Italic": [
    "Normal,Italic"
  ],
  "Saltire": [
    "Normal,Normal"
  ],
  "Cassatta Zig": [
    "Normal,Normal"
  ],
  "OCR A Extended": [
    "Normal,Normal"
  ],
  "Rub This!": [
    "Bold,Normal"
  ],
  "RRHeralds": [
    "Normal,Normal"
  ],
  "Ubuntu Light": [
    "Light,Normal",
    "Light,Italic",
    "Medium,Normal",
    "Medium,Italic"
  ],
  "Libritabs": [
    "Normal,Normal"
  ],
  "ILL oMen": [
    "Normal,Normal"
  ],
  "Liquidism part 2": [
    "Normal,Normal"
  ],
  "Helvetica Neue LT 2": [
    "Bold,Normal"
  ],
  "Dutch 801 SWA": [
    "Normal,Italic"
  ],
  "HelveticaNeueLT Std Blk": [
    "Black,Normal"
  ],
  "Sylfaen": [
    "Normal,Normal"
  ],
  "MS Outlook": [
    "Normal,Normal"
  ],
  "TNR Liborius ": [
    "Normal,Normal"
  ],
  "QUAKE": [
    "Normal,Normal"
  ],
  "Code Pro Bold": [
    "Bold,Normal"
  ],
  "Helvetica Cyrillic Upright": [
    "Medium,Normal"
  ],
  "Helvetica Narrow Profi": [
    "Bold,Normal"
  ],
  "Zero Gravity": [
    "Normal,Italic"
  ],
  "LeedsCyr Koi8_4": [
    "Normal,Normal"
  ],
  "Mattbats": [
    "Normal,Normal"
  ],
  "Yanone Kaffeesatz Regular": [
    "Normal,Normal"
  ],
  "Nite": [
    "Medium,Normal"
  ],
  "SpeedballNo2SW": [
    "Normal,Normal"
  ],
  "Helvetica-Narrow Lefty": [
    "Medium,Normal"
  ],
  "Magehunter": [
    "Normal,Normal"
  ],
  "Old Oak": [
    "Normal,Normal"
  ],
  "Year 3000 Pro": [
    "Normal,Normal"
  ],
  "Calibri": [
    "Normal,Normal",
    "Bold,Normal",
    "Normal,Italic"
  ],
  "Intro Thin": [
    "Thin,Normal"
  ],
  "Milonga": [
    "Normal,Normal"
  ],
  "STHupo": [
    "Normal,Normal"
  ],
  "LiquidCrystal": [
    "Normal,Normal"
  ],
  "Realpolitik": [
    "Normal,Normal"
  ],
  "ArTarumianMatenagir": [
    "Normal,Normal"
  ],
  "Belleza": [
    "Normal,Normal"
  ],
  "Ghouly Solid": [
    "Medium,Normal"
  ],
  "Core Sans A 25 ExtraLight": [
    "ExtraLight,Italic",
    "ExtraLight,Normal"
  ],
  "Italianno": [
    "Normal,Normal"
  ],
  "Z machine (sRB)": [
    "Normal,Normal"
  ],
  "Intro Bold Alt": [
    "Bold,Normal"
  ],
  "Times New Roman": [
    "Bold,Normal",
    "Bold,Italic",
    "Normal,Italic",
    "Normal,Normal"
  ],
  "Nexa Slab Book Oblique": [
    "Normal,Oblique"
  ],
  "Helvetica73-Extended": [
    "Bold,Normal"
  ],
  "Tornado": [
    "Normal,Normal"
  ],
  "KabinConMedDB": [
    "Normal,Normal"
  ],
  "Anton": [
    "Normal,Normal"
  ],
  "Nina": [
    "Normal,Normal",
    "Bold,Normal"
  ],
  "Code Pro Demo": [
    "Normal,Normal"
  ],
  "HoratioDMed": [
    "Normal,Normal"
  ],
  "Vietnamese": [
    "Normal,Normal"
  ],
  "Spit Shine": [
    "Normal,Normal"
  ],
  "Rockwell Extra Bold": [
    "ExtraBold,Normal"
  ],
  "Ribeye": [
    "Normal,Normal"
  ],
  "Courier New": [
    "Normal,Normal",
    "Bold,Normal",
    "Bold,Italic",
    "Normal,Italic"
  ],
  "Xolto": [
    "Normal,Normal"
  ],
  "Exo": [
    "Black,Normal",
    "Black,Italic",
    "Bold,Normal",
    "Bold,Italic",
    "ExtraBold,Normal",
    "ExtraBold,Italic",
    "ExtraLight,Normal",
    "ExtraLight,Italic",
    "Normal,Italic",
    "Light,Normal",
    "Light,Italic",
    "Medium,Normal",
    "Medium,Italic",
    "Normal,Normal",
    "SemiBold,Normal",
    "SemiBold,Italic",
    "Thin,Normal",
    "Thin,Italic"
  ],
  "Airmole": [
    "Normal,Normal"
  ],
  "MS Mincho": [
    "Normal,Normal"
  ],
  "ER Bukinist 866": [
    "Normal,Italic"
  ],
  "Wait And Bleed": [
    "Normal,Normal"
  ],
  "Proxima Nova Cn Lt": [
    "Light,Normal",
    "Light,Italic",
    "SemiBold,Normal",
    "SemiBold,Italic"
  ],
  "HelveticaNeueLT Std Med Cn": [
    "Medium,Normal",
    "Medium,Oblique"
  ],
  "Gas Huffer Phat": [
    "Normal,Normal"
  ],
  "Helvetica LT Std Cond Light": [
    "Light,Normal",
    "Light,Oblique"
  ],
  "Intro Cond Black Alt": [
    "Black,Normal"
  ],
  "Regular": [
    "Normal,Normal"
  ],
  "Alba": [
    "Normal,Normal"
  ],
  "Helvetica Inserat BQ": [
    "Medium,Italic",
    "Medium,Normal"
  ],
  "HamburgerHeaven": [
    "Normal,Normal"
  ],
  "Harlow Solid Italic": [
    "Normal,Italic"
  ],
  "CloisterOpenFace BT": [
    "Normal,Normal"
  ],
  "Helvetica83-ExtendedHeavy": [
    "Black,Normal"
  ],
  "Helvetica Cyrillic A": [
    "Bold,Normal",
    "Bold,Oblique",
    "Medium,Oblique"
  ],
  "ArabicRiyadhSSK": [
    "Normal,Normal"
  ],
  "International Super Hero Exp": [
    "Normal,Normal"
  ],
  "Hammer": [
    "Black,Normal"
  ],
  "Laffayette Comic Pro": [
    "Normal,Normal"
  ],
  "Saffron": [
    "Normal,Normal"
  ],
  "Ren And Stimpy": [
    "Medium,Normal"
  ],
  "Ubuntu": [
    "Bold,Normal",
    "Bold,Italic",
    "Normal,Italic",
    "Normal,Normal"
  ],
  "LiddieBlack": [
    "Medium,Normal"
  ],
  "HelveticaNeue ExtBlackCond": [
    "Black,Normal",
    "Black,Oblique"
  ],
  "Pravda Fixed Pitch": [
    "Normal,Normal"
  ],
  "Rock Star": [
    "Normal,Normal"
  ],
  "SURROUNDED large": [
    "Normal,Normal"
  ],
  "CrrCTT": [
    "Bold,Normal"
  ],
  "Helvetica-Condensed-Thin": [
    "Thin,Normal"
  ],
  "HelveticaNeueLT Std UltLt Ext": [
    "ExtraLight,Normal",
    "ExtraLight,Oblique"
  ],
  "Wendy One": [
    "Normal,Normal"
  ],
  "Electroharmonix": [
    "Normal,Normal"
  ],
  "Intro Black Caps": [
    "Black,Normal"
  ],
  "ROCKY AOE": [
    "Normal,Normal"
  ],
  "Rod Transparent": [
    "Normal,Normal"
  ],
  "Bradley Hand ITC": [
    "Normal,Normal"
  ],
  "Serifa Blk BT": [
    "Black,Normal"
  ],
  "Xdvng": [
    "Normal,Normal"
  ],
  "Vox-Slanted": [
    "Normal,Oblique"
  ],
  "Uqammaq Heavy": [
    "Black,Normal"
  ],
  "Revel Light": [
    "Light,Normal"
  ],
  "Macedo": [
    "Medium,Normal"
  ],
  "Intro Regular": [
    "Normal,Normal"
  ],
  "Dark Horse": [
    "Normal,Normal"
  ],
  "Et tu, Brute?": [
    "Normal,Normal"
  ],
  "Script MT Bold": [
    "Bold,Normal"
  ],
  "Babe Bamboo": [
    "Normal,Normal"
  ],
  "Helvetica-Condensed-Light-Light": [
    "Light,Normal"
  ],
  "Vixar ASCI": [
    "Normal,Normal"
  ],
  "VPS Tuyen Duc Hoa": [
    "Normal,Normal"
  ],
  "Gill Sans Ultra Bold": [
    "ExtraBold,Normal"
  ],
  "Franklin Gothic Book": [
    "Normal,Normal"
  ],
  "Condiment": [
    "Normal,Normal"
  ],
  "Reynard Demo": [
    "Normal,Normal"
  ],
  "Helvetica_Light-Normal": [
    "Light,Normal"
  ],
  "Proxima Nova Lt": [
    "Light,Normal",
    "Light,Italic",
    "SemiBold,Normal",
    "SemiBold,Italic"
  ],
  "Ramose": [
    "Normal,Oblique"
  ],
  "Bookshelf Symbol 7": [
    "Normal,Normal"
  ],
  "GeoBats": [
    "Normal,Normal"
  ],
  "Helvetica Neue 2": [
    "Bold,Normal",
    "Bold,Italic"
  ],
  "K.P. Duty Overtime JL": [
    "Normal,Normal"
  ],
  "Sansation": [
    "Normal,Normal"
  ],
  "Webdunia": [
    "Normal,Normal"
  ],
  "Orbitron": [
    "Black,Normal",
    "Bold,Normal",
    "Medium,Normal",
    "Normal,Normal"
  ],
  "MarionsHand": [
    "Medium,Normal"
  ],
  "Quiet Infinity": [
    "Normal,Normal"
  ],
  "Rosegarden": [
    "Normal,Normal"
  ],
  "Raptor Attack": [
    "Normal,Normal"
  ],
  "Pristina": [
    "Normal,Normal"
  ],
  "Feuerfeste": [
    "Normal,Normal"
  ],
  "LifeT": [
    "Normal,Italic"
  ],
  "Helvetica Black": [
    "Black,Normal",
    "Black,Oblique",
    "Black,Italic"
  ],
  "Helvetica57-Condensed": [
    "Normal,Normal"
  ],
  "Iceberg": [
    "Normal,Normal"
  ],
  "Estrangelo Edessa": [
    "Normal,Normal"
  ],
  "RubaiyatEngraved": [
    "Normal,Normal"
  ],
  "Vladimir Script": [
    "Normal,Normal"
  ],
  "Helvetica-Condensed-Black-Se": [
    "Black,Normal"
  ],
  "Roboto Black": [
    "Black,Normal",
    "Black,Italic"
  ],
  "Allan": [
    "Bold,Italic",
    "Normal,Normal"
  ],
  "CordiaUPC": [
    "Normal,Normal",
    "Bold,Normal",
    "Normal,Italic",
    "Bold,Italic"
  ],
  "Euphemia UCAS": [
    "Bold,Normal",
    "Normal,Italic",
    "Normal,Normal"
  ],
  "High Tower Text": [
    "Normal,Normal",
    "Normal,Italic"
  ],
  "Suske And Wiske": [
    "Normal,Normal"
  ],
  "FeltMark": [
    "Medium,Italic"
  ],
  "WeInside": [
    "Medium,Normal"
  ],
  "Masterforce Solid": [
    "Medium,Normal"
  ],
  "Helvetica-Narrow": [
    "Bold,Oblique",
    "Medium,Italic",
    "Normal,Oblique",
    "Medium,Normal",
    "Normal,Normal",
    "Bold,Normal"
  ],
  "Yellowtail": [
    "Normal,Normal"
  ],
  "Haettenschweiler": [
    "Normal,Normal"
  ],
  "Myopia": [
    "Normal,Normal"
  ],
  "Tanline": [
    "Normal,Normal"
  ],
  "Intro Cond": [
    "Light,Italic",
    "Thin,Normal",
    "Thin,Italic"
  ],
  "Chiller": [
    "Normal,Normal"
  ],
  "HelveticaExtO 2": [
    "Normal,Normal"
  ],
  "Impossible - 500": [
    "Normal,Normal"
  ],
  "Cookie": [
    "Normal,Normal"
  ],
  "Droid Sans": [
    "Bold,Normal",
    "Normal,Normal"
  ],
  "Eras Light ITC": [
    "Light,Normal"
  ],
  "Colo-Light": [
    "Light,Normal"
  ],
  "HelveticaNeue Condensed": [
    "Normal,Oblique"
  ],
  "Cinzel": [
    "Bold,Normal",
    "Normal,Normal"
  ],
  "Palatino Linotype": [
    "Normal,Normal",
    "Bold,Normal",
    "Bold,Italic",
    "Normal,Italic"
  ],
  "Swirled (BRK)": [
    "Normal,Normal"
  ],
  "NexaRegular": [
    "Normal,Normal"
  ],
  "HVD Comic Serif Pro": [
    "Normal,Normal"
  ],
  "QuotaBlack DB": [
    "Bold,Normal"
  ],
  "Core Sans A 55 Medium": [
    "Normal,Italic",
    "Normal,Normal"
  ],
  "Lefferts Corners  2": [
    "Normal,Normal"
  ],
  "Code Bold": [
    "Bold,Normal"
  ],
  "Mad scientist": [
    "Normal,Normal"
  ],
  "Junegull": [
    "Normal,Normal"
  ],
  "Felix Titling": [
    "Normal,Normal"
  ],
  "Helvetica Neue LT": [
    "Light,Normal",
    "Thin,Normal"
  ],
  "Playbill": [
    "Normal,Normal"
  ],
  "Algerian": [
    "Normal,Normal"
  ],
  "u26fog": [
    "Normal,Normal"
  ],
  "QTOptimum": [
    "Medium,Italic"
  ],
  "Niconne": [
    "Normal,Normal"
  ],
  "Tunga": [
    "Normal,Normal"
  ],
  "Scroll": [
    "Normal,Normal"
  ],
  "ArTarumianGrqiNor": [
    "Bold,Normal"
  ],
  "Hammerhead": [
    "Normal,Normal",
    "Bold,Normal"
  ],
  "KG Blank Space Sketch": [
    "Normal,Normal"
  ],
  "Joe": [
    "Medium,Normal"
  ],
  "Helvetica75Outline": [
    "Bold,Normal"
  ],
  "HelveticaNeueLT Std Med": [
    "Medium,Normal"
  ],
  "HanWangMingHeavy": [
    "Normal,Normal"
  ],
  "Bookman Old Style": [
    "Light,Normal",
    "SemiBold,Normal",
    "SemiBold,Italic",
    "Light,Italic"
  ],
  "AngsanaUPC": [
    "Normal,Normal"
  ],
  "Galindo": [
    "Normal,Normal"
  ],
  "7 days": [
    "Normal,Normal"
  ],
  "ArTarumianMHarvats": [
    "Normal,Normal"
  ],
  "Retsuc": [
    "Normal,Normal"
  ],
  "SidTheSpider": [
    "Normal,Normal"
  ],
  "Helvetica43-ExtendedLight": [
    "Light,Normal"
  ],
  "Martel": [
    "Normal,Normal"
  ],
  "Trebuchet MS": [
    "Normal,Normal",
    "Bold,Normal",
    "Bold,Italic",
    "Normal,Italic"
  ],
  "Ogilvie": [
    "Medium,Normal"
  ],
  "Riquoth": [
    "Normal,Normal"
  ],
  "Radiated Pancake": [
    "Normal,Normal"
  ],
  "Colonna MT": [
    "Normal,Normal"
  ],
  "Intrepid ExtraBold": [
    "ExtraBold,Normal"
  ],
  "Roboto Condensed Light": [
    "Light,Normal",
    "Light,Italic"
  ],
  "Archer Medium": [
    "Medium,Normal",
    "Medium,Italic"
  ],
  "Nexa-Bold": [
    "Bold,Normal"
  ],
  "Berthside": [
    "Normal,Normal"
  ],
  "Something Fishy": [
    "Normal,Normal"
  ],
  "Leger": [
    "Normal,Normal"
  ],
  "David": [
    "Normal,Normal"
  ],
  "Nexa Slab Regular Oblique": [
    "Normal,Oblique"
  ],
  "HelveticaNeueLT Std Blk Cn": [
    "Black,Normal",
    "Black,Oblique"
  ],
  "Uqammaq": [
    "Bold,Normal",
    "Normal,Normal"
  ],
  "Helvetica Condensed Light": [
    "Light,Normal"
  ],
  "Makisupa": [
    "Normal,Normal"
  ],
  "gogo squat": [
    "Normal,Normal"
  ],
  "Miriam": [
    "Normal,Normal"
  ],
  "Nestor": [
    "Normal,Normal"
  ],
  "HelveticaNeueLT Std Thin Cn": [
    "Thin,Normal",
    "Thin,Oblique"
  ],
  "Stephen": [
    "Medium,Normal"
  ],
  "Notepad": [
    "Normal,Normal"
  ],
  "Peralta": [
    "Normal,Normal"
  ],
  "Montserrat Light": [
    "Light,Normal"
  ],
  "Stencil": [
    "Normal,Normal"
  ],
  "Astron Boy Video": [
    "Normal,Normal"
  ],
  "QuickExpress": [
    "Normal,Normal"
  ],
  "Qanelas Soft Black": [
    "Black,Normal"
  ],
  "Intro Cond SemBd Alt": [
    "SemiBold,Normal"
  ],
  "Miniver": [
    "Normal,Normal"
  ],
  "Gabriela": [
    "Normal,Normal"
  ],
  "Bauhaus 93": [
    "Normal,Normal"
  ],
  "Helvetica Rounded LT Condensed": [
    "Bold,Normal"
  ],
  "Helvetica56": [
    "Normal,Italic"
  ],
  "T": [
    "Medium,Normal"
  ],
  "Core Sans A 85 Heavy": [
    "Black,Italic",
    "Black,Normal"
  ],
  "ResPublica": [
    "Normal,Normal"
  ],
  "Lindas Lament": [
    "Normal,Normal"
  ],
  "Shipper": [
    "Medium,Normal"
  ],
  "Uqammaq Light": [
    "Light,Normal"
  ],
  "Dead Alive": [
    "Normal,Normal"
  ],
  "HelveNueThin": [
    "Normal,Normal"
  ],
  "Englebert": [
    "Normal,Normal"
  ],
  "Randi": [
    "Normal,Normal"
  ],
  "Nexa Slab Book": [
    "Normal,Normal"
  ],
  "Intro Cond SemBd": [
    "SemiBold,Normal",
    "SemiBold,Italic"
  ],
  "Real Horror Show": [
    "Normal,Normal"
  ],
  "Chinese Cally TFB": [
    "Normal,Normal"
  ],
  "DokChampa": [
    "Normal,Normal"
  ],
  "A Love of Thunder": [
    "Normal,Normal"
  ],
  "Intro Cond Caps Black": [
    "Black,Normal"
  ],
  "Numskull (BRK)": [
    "Normal,Normal"
  ],
  "Damion": [
    "Normal,Normal"
  ],
  "Metamorphous": [
    "Normal,Normal"
  ],
  "Vollkorn Italic": [
    "Normal,Italic"
  ],
  "Intro Cond Alt": [
    "Normal,Normal",
    "Bold,Normal"
  ],
  "Still Time": [
    "Normal,Normal"
  ],
  "HelveticaInserat-Roman-SemiB": [
    "Normal,Normal"
  ],
  "Yanone Kaffeesatz Thin": [
    "250,Normal"
  ],
  "Quintessential": [
    "Normal,Normal"
  ],
  "Umpyre": [
    "Normal,Normal"
  ],
  "STXinwei": [
    "Normal,Normal"
  ],
  "Eras Medium ITC": [
    "Normal,Normal"
  ],
  "AntoniousJ": [
    "Normal,Normal"
  ],
  "Science Project": [
    "Normal,Normal"
  ],
  "Iphegenia": [
    "Normal,Normal"
  ],
  "ParisMetro": [
    "Medium,Normal"
  ],
  "Rivanna": [
    "Normal,Normal"
  ],
  "Philosopher": [
    "Bold,Normal",
    "Bold,Italic",
    "Normal,Italic",
    "Normal,Normal"
  ],
  "LTColibri": [
    "Normal,Normal"
  ],
  "Bandit": [
    "Medium,Normal"
  ],
  "Helvetica LT Std": [
    "Bold,Normal",
    "Bold,Oblique",
    "Normal,Oblique",
    "Normal,Normal"
  ],
  "NobbiGConDB": [
    "Normal,Normal"
  ],
  "Back to Bay 6": [
    "Normal,Normal"
  ],
  "Kantor Ligatures": [
    "Normal,Normal"
  ],
  "Maharlika": [
    "Normal,Normal"
  ],
  "SF Arch Rival Extended": [
    "Normal,Italic"
  ],
  "HelveticaNeueLT Std Lt": [
    "Light,Normal"
  ],
  "Lucida Sans": [
    "Normal,Normal",
    "SemiBold,Normal",
    "SemiBold,Italic",
    "Normal,Italic"
  ],
  "Fixed Miriam Transparent": [
    "Normal,Normal"
  ],
  "RemiHead": [
    "Normal,Normal"
  ],
  "Geeves": [
    "Normal,Normal"
  ],
  "Blue Highway Linocut": [
    "Normal,Normal"
  ],
  "Arimo": [
    "Bold,Normal",
    "Bold,Italic",
    "Normal,Italic",
    "Normal,Normal"
  ],
  "VPS Pleiku Hoa": [
    "Bold,Italic"
  ],
  "ArcherPro Hairline": [
    "Thin,Normal",
    "Thin,Italic"
  ],
  "Xeroprint": [
    "Normal,Normal"
  ],
  "TradeGothic Bold": [
    "Bold,Normal"
  ],
  "Webdings": [
    "Normal,Normal"
  ],
  "Cabin": [
    "Bold,Normal",
    "Bold,Italic",
    "Normal,Italic",
    "Medium,Normal",
    "Medium,Italic",
    "Normal,Normal",
    "SemiBold,Normal",
    "SemiBold,Italic"
  ],
  "Swollen": [
    "Normal,Normal"
  ],
  "Baroness Kuffner": [
    "Normal,Normal"
  ],
  "Nilland-ExtraBold": [
    "ExtraBold,Normal"
  ],
  "Short Hand": [
    "Normal,Normal"
  ],
  "RaveParty Hollow": [
    "Normal,Normal"
  ],
  "XBAND Rough": [
    "Normal,Normal"
  ],
  "Tarnished Halo": [
    "Normal,Normal"
  ],
  "Britannic Bold": [
    "Bold,Normal"
  ],
  "Old English Text MT": [
    "Normal,Normal"
  ],
  "Nexa Slab Light": [
    "Light,Normal"
  ],
  "Machiavelli": [
    "Medium,Italic"
  ],
  "Intro Light Caps": [
    "Light,Normal"
  ],
  "Copperplate Gothic Bold": [
    "Bold,Normal"
  ],
  "Nexa-Thin-Italic": [
    "Thin,Italic"
  ],
  "KG Broken Vessels Sketch": [
    "Normal,Normal"
  ],
  "STSong": [
    "Normal,Normal"
  ],
  "Sniff": [
    "Normal,Italic"
  ],
  "Neuropolitical": [
    "Normal,Normal"
  ],
  "Century": [
    "Normal,Normal"
  ],
  "RoselleCapsSSK": [
    "Normal,Italic"
  ],
  "GiantTigers": [
    "Normal,Normal"
  ],
  "Franklin Gothic Medium": [
    "Normal,Normal",
    "Normal,Italic"
  ],
  "Ghostmeat": [
    "Normal,Normal"
  ],
  "Playball": [
    "Normal,Normal"
  ],
  "Code Pro": [
    "Normal,Normal"
  ],
  "QTHowardType": [
    "Medium,Normal"
  ],
  "MarlonDB": [
    "Normal,Normal"
  ],
  "Helvetica LT Std Black": [
    "Black,Normal",
    "Black,Oblique"
  ],
  "Scary Monsters": [
    "Normal,Normal"
  ],
  "WaldauDB": [
    "Normal,Normal"
  ],
  "Tanne DB": [
    "Normal,Normal"
  ],
  "Gill Sans MT Condensed": [
    "Normal,Normal"
  ],
  "Helvetica-Black-SemiBold": [
    "SemiBold,Normal"
  ],
  "Helvetica Inserat": [
    "Medium,Normal",
    "Normal,Normal"
  ],
  "SF Collegiate Solid": [
    "Normal,Italic"
  ],
  "Code Pro Light LC": [
    "Light,Normal"
  ],
  "Arial": [
    "Normal,Normal"
  ],
  "Nine Lives": [
    "Normal,Normal"
  ],
  "YouYuan": [
    "Normal,Normal"
  ],
  "orange juice": [
    "Normal,Normal"
  ],
  "Code Pro Light Demo": [
    "Light,Normal"
  ],
  "Code Pro Black": [
    "Black,Normal"
  ],
  "Skull Capz (BRK)": [
    "Normal,Normal"
  ],
  "Helvetica Fractions BQ": [
    "Medium,Normal"
  ],
  "Bebas Neue Book": [
    "Normal,Normal"
  ],
  "Lower-WestSide": [
    "Medium,Normal"
  ],
  "Kaptain Toupe": [
    "Normal,Normal"
  ],
  "Sniglet": [
    "ExtraBold,Normal",
    "Normal,Normal"
  ],
  "Helvetica Extended BQ": [
    "Medium,Normal"
  ],
  "Marburg DB": [
    "Normal,Normal"
  ],
  "Horley Old Style MT": [
    "Normal,Normal"
  ],
  "Helvetica LT Std  steevo harvie": [
    "Normal,Normal"
  ],
  "District": [
    "Normal,Normal"
  ],
  "Helvetica-Narrow-Bold Lefty": [
    "Bold,Normal"
  ],
  "Nuance": [
    "Normal,Italic"
  ],
  "LTAfroculture": [
    "Normal,Normal"
  ],
  "Nexa Slab Black": [
    "Black,Normal"
  ],
  "HelveticaNeueLT Std Lt Ext": [
    "Light,Normal",
    "Light,Oblique"
  ],
  "Intro Cond Light Alt": [
    "Light,Normal"
  ],
  "IGaramond": [
    "Medium,Normal"
  ],
  "Bangers": [
    "Normal,Normal"
  ],
  "HanWangYenHeavy": [
    "Normal,Normal"
  ],
  "Oswald": [
    "Bold,Normal",
    "Light,Normal",
    "Normal,Normal"
  ],
  "National First Font": [
    "Normal,Normal"
  ],
  "Rubber Walls": [
    "Normal,Normal"
  ],
  "LTSicula": [
    "Normal,Oblique"
  ],
  "Sujeta Outline": [
    "Light,Normal"
  ],
  "Ridicule": [
    "Normal,Normal"
  ],
  "ArcherPro Semibold": [
    "SemiBold,Normal",
    "SemiBold,Italic"
  ],
  "Rage Italic": [
    "Normal,Italic"
  ],
  "Capriola": [
    "Normal,Normal"
  ],
  "Impact": [
    "Normal,Normal"
  ],
  "Helvetica CE Cond": [
    "Medium,Normal",
    "Bold,Normal",
    "Bold,Oblique",
    "Normal,Oblique"
  ],
  "Hallisey": [
    "Normal,Normal"
  ],
  "Rupee": [
    "Normal,Normal"
  ],
  "Latha": [
    "Normal,Normal"
  ],
  "STLiti": [
    "Normal,Normal"
  ],
  "Vrinda": [
    "Normal,Normal"
  ],
  "Narkisim": [
    "Normal,Normal"
  ],
  "Rat Man Bane": [
    "Normal,Normal"
  ],
  "YellowSubmarine": [
    "Normal,Normal"
  ],
  "Intro Thin Italic": [
    "Thin,Italic"
  ],
  "Lifetime": [
    "Normal,Normal"
  ],
  "Rx-FiveOne": [
    "Medium,Normal"
  ],
  "Intro Regular Caps": [
    "Normal,Normal"
  ],
  "Lois Ann": [
    "Normal,Normal"
  ],
  "Volt": [
    "Normal,Normal"
  ],
  "ArTarumianHamagumar": [
    "Normal,Normal"
  ],
  "Roboto Light": [
    "Light,Normal",
    "Light,Italic"
  ],
  "Trochut": [
    "Bold,Normal",
    "Normal,Italic",
    "Normal,Normal"
  ],
  "Symbol Set SWA": [
    "Normal,Normal"
  ],
  "Misconstrued": [
    "Normal,Normal"
  ],
  "Mael": [
    "Normal,Normal"
  ],
  "Vitamin": [
    "Normal,Normal"
  ],
  "Boomerang": [
    "Normal,Normal",
    "Normal,Italic"
  ],
  "ArcherPro Bold": [
    "Bold,Normal",
    "Bold,Italic"
  ],
  "Sanguinary": [
    "Normal,Normal"
  ],
  "Andalus": [
    "Normal,Normal"
  ],
  "Quartermain Condensed": [
    "Normal,Normal"
  ],
  "Zona Pro Bold": [
    "Bold,Normal"
  ],
  "Intro Bold": [
    "Bold,Normal"
  ],
  "HammerheadOutline": [
    "Normal,Normal"
  ],
  "Stoke": [
    "Light,Normal",
    "Normal,Normal"
  ],
  "Castellar": [
    "Normal,Normal"
  ],
  "Intro Black": [
    "Black,Normal"
  ],
  "Kartika": [
    "Normal,Normal"
  ],
  "Franklin Gothic Medium Cond": [
    "Normal,Normal"
  ],
  "screenfox9": [
    "Normal,Normal"
  ],
  "Helvetica World": [
    "Bold,Normal",
    "Bold,Italic",
    "Normal,Italic",
    "Normal,Normal"
  ],
  "Proxima Nova Bl": [
    "Black,Normal"
  ],
  "Gruppo": [
    "Normal,Normal"
  ],
  "SF Cartoonist Hand": [
    "Normal,Italic"
  ],
  "David Transparent": [
    "Normal,Normal"
  ],
  "Montserrat Extra Bold": [
    "ExtraBold,Normal"
  ],
  "Ravie": [
    "Normal,Normal"
  ],
  "Nexa Slab Bold": [
    "Bold,Normal"
  ],
  "Japanette DB": [
    "Medium,Normal"
  ],
  "JG ChamVN": [
    "Normal,Normal"
  ],
  "Helvetica Cyrillic": [
    "Bold,Normal",
    "Bold,Oblique",
    "Medium,Oblique"
  ],
  "neo-geo": [
    "Normal,Normal"
  ],
  "SF Comic Script": [
    "Normal,Normal"
  ],
  "Intro Cond Black": [
    "Black,Normal",
    "Black,Italic"
  ],
  "Helvetica LT Std Cond Blk": [
    "Black,Normal",
    "Black,Oblique"
  ],
  "Xefus": [
    "Normal,Normal"
  ],
  "Oblivious font": [
    "Normal,Normal"
  ],
  "Zamboni Joe Expanded": [
    "Normal,Normal"
  ],
  "Viner Hand ITC": [
    "Normal,Normal"
  ],
  "Trajan Pro": [
    "Bold,Normal"
  ],
  "Cream and sugar": [
    "Normal,Normal"
  ],
  "Lizzard": [
    "Normal,Normal"
  ],
  "Boogaloo": [
    "Normal,Normal"
  ],
  "CaligulaDodgy": [
    "Normal,Normal"
  ],
  "Belphebe": [
    "Normal,Normal"
  ],
  "Modern No. 20": [
    "Normal,Normal"
  ],
  "Occoluchi Italic": [
    "Normal,Italic"
  ],
  "stillframes": [
    "Normal,Normal"
  ],
  "Carbon Block": [
    "Normal,Normal"
  ],
  "HelveticaNeue MediumCond": [
    "Normal,Normal",
    "Normal,Oblique",
    "Black,Normal",
    "Black,Oblique"
  ],
  "Freestyle Script": [
    "Normal,Normal"
  ],
  "Cyberia": [
    "Normal,Normal"
  ],
  "Yellowjacket Expanded": [
    "Normal,Normal"
  ],
  "Bubble 1": [
    "Normal,Normal"
  ],
  "Nexa Slab xBold": [
    "ExtraBold,Normal"
  ],
  "Lunch time": [
    "Normal,Normal"
  ],
  "Narcotix": [
    "Normal,Normal"
  ],
  "Helvetica Inserat LT Std": [
    "ExtraBold,Normal"
  ],
  "Helvetica93-ExtendedBlack": [
    "Black,Normal"
  ],
  "Archer Light": [
    "Light,Normal",
    "Light,Italic"
  ],
  "wmtrees1": [
    "Normal,Normal"
  ],
  "Gigi": [
    "Normal,Normal"
  ],
  "ArcherPro Medium": [
    "Medium,Normal",
    "Medium,Italic"
  ],
  "Intro Book": [
    "Normal,Normal"
  ],
  "WarnSymbols1": [
    "Normal,Normal"
  ],
  "Ciula": [
    "Normal,Normal"
  ],
  "WallStreet": [
    "Normal,Normal"
  ],
  "Gnuolane Rg": [
    "Normal,Normal"
  ],
  "Showcard Gothic": [
    "Normal,Normal"
  ],
  "Stranded (BRK)": [
    "Normal,Normal"
  ],
  "Portugal": [
    "Bold,Italic"
  ],
  "Intro Regular Italic": [
    "Normal,Italic"
  ],
  "Oregon": [
    "Medium,Normal"
  ],
  "Helvetica Rounded LT Black": [
    "Black,Normal"
  ],
  "Lab Bats": [
    "Normal,Normal"
  ],
  "I Want My TTR!": [
    "Normal,Normal"
  ],
  "Royal Pain": [
    "Normal,Normal"
  ],
  "Ubuntu Condensed": [
    "Normal,Normal"
  ],
  "RuttenSpya": [
    "Normal,Normal"
  ],
  "Imprint MT Shadow": [
    "Normal,Normal"
  ],
  "Helvetica75": [
    "Bold,Normal"
  ],
  "Helvetica Neue Black": [
    "Black,Normal"
  ],
  "Undercover": [
    "Normal,Normal"
  ],
  "Seeing Stars": [
    "Normal,Normal"
  ],
  "MoonbeamsHiragana": [
    "Normal,Normal"
  ],
  "ArTarumianKamar": [
    "Normal,Normal"
  ],
  "JackInput": [
    "Normal,Normal"
  ],
  "Nocker": [
    "Normal,Normal"
  ],
  "Bulgarian Italic": [
    "Normal,Italic"
  ],
  "Pravda": [
    "Normal,Italic"
  ],
  "Pastor of Muppets": [
    "Normal,Normal"
  ],
  "Amaranth": [
    "Bold,Normal",
    "Bold,Italic",
    "Normal,Italic",
    "Normal,Normal"
  ],
  "Parchment": [
    "Normal,Normal"
  ],
  "Engravers MT": [
    "Medium,Normal"
  ],
  "Pooja": [
    "Normal,Normal"
  ],
  "Dosis": [
    "Bold,Normal",
    "ExtraBold,Normal",
    "ExtraLight,Normal",
    "Light,Normal",
    "Medium,Normal",
    "Normal,Normal",
    "SemiBold,Normal"
  ],
  "Lazuri COSMIC": [
    "Medium,Italic"
  ],
  "Cursiv": [
    "Normal,Normal"
  ],
  "KoffeeDBol": [
    "Normal,Normal"
  ],
  "BaltUniversity": [
    "Normal,Normal"
  ],
  "Unionform": [
    "Normal,Normal"
  ],
  "Scriptina": [
    "Normal,Normal"
  ],
  "Chupada": [
    "Bold,Italic",
    "Bold,Normal",
    "Normal,Italic",
    "Normal,Normal"
  ],
  "Helvetica65-Medium": [
    "Medium,Normal",
    "Normal,Italic",
    "Black,Normal"
  ],
  "Road Hoe": [
    "Normal,Normal"
  ],
  "Elbjorg": [
    "Normal,Normal"
  ],
  "QTHowardTypeFat": [
    "Medium,Normal"
  ],
  "Intro Cond Light": [
    "Light,Normal"
  ],
  "Serbian-Courier": [
    "Normal,Normal"
  ],
  "Chupada Demibold": [
    "SemiBold,Italic",
    "SemiBold,Normal"
  ],
  "Bearpaw": [
    "Normal,Normal"
  ],
  "Nebraska": [
    "Normal,Italic"
  ],
  "Nexa-Heavy-Italic": [
    "Black,Italic"
  ],
  "CyrCauc": [
    "Medium,Normal"
  ],
  "MammaGamma": [
    "Normal,Normal"
  ],
  "SF Archery Black SC": [
    "Black,Oblique"
  ],
  "Nexa Slab Heavy Oblique": [
    "Black,Oblique"
  ],
  "Magdalena": [
    "Medium,Normal"
  ],
  "Niagara Engraved": [
    "Normal,Normal"
  ],
  "Helvetica LT Std ExtCompressed": [
    "Normal,Normal"
  ],
  "Napapiiri": [
    "Normal,Normal"
  ],
  "Alba Super": [
    "Normal,Normal"
  ],
  "StickAroundForJoy": [
    "Normal,Normal"
  ],
  "Nexa Slab xBold Italic": [
    "ExtraBold,Italic"
  ],
  "Alegreya": [
    "Black,Normal",
    "Black,Italic",
    "Bold,Normal",
    "Bold,Italic",
    "Normal,Italic",
    "Normal,Normal"
  ],
  "Oconnor": [
    "Medium,Normal"
  ],
  "Shoestore": [
    "Normal,Normal"
  ],
  "Radonator Anorexia": [
    "Normal,Normal"
  ],
  "Blackadder ITC": [
    "Normal,Normal"
  ],
  "Lazuri ATHLETIC": [
    "Normal,Normal"
  ],
  "Miserable": [
    "Normal,Normal"
  ],
  "Lemon": [
    "Normal,Normal"
  ],
  "Univers LT 57 Condensed": [
    "Normal,Normal"
  ],
  "Rokford": [
    "Normal,Normal"
  ],
  "Royal box": [
    "Normal,Normal"
  ],
  "Gotham Medium": [
    "Medium,Normal"
  ],
  "ER Architect": [
    "Normal,Normal"
  ],
  "Satisfy": [
    "Normal,Normal"
  ],
  "Bell MT": [
    "Normal,Normal",
    "Bold,Normal",
    "Normal,Italic"
  ],
  "Outer Limits Solid": [
    "Normal,Italic",
    "Normal,Normal"
  ],
  "Monsters Attack!": [
    "Normal,Normal"
  ],
  "HelveticaObl-Li": [
    "Normal,Normal"
  ],
  "NexaHeavy": [
    "Normal,Normal"
  ],
  "Revue BT": [
    "Normal,Normal"
  ],
  "Starlight Sans JL": [
    "Normal,Normal"
  ],
  "StrokeyBacon": [
    "Normal,Normal"
  ],
  "Helvetica63-ExtendedMedium": [
    "Medium,Normal"
  ],
  "Helvetica LT Std UltCompressed": [
    "Normal,Normal"
  ],
  "Arial Black": [
    "Black,Normal"
  ],
  "Archer Thin": [
    "Thin,Normal",
    "Thin,Italic"
  ],
  "Mistral": [
    "Normal,Normal"
  ],
  "Rage Italic LET": [
    "Medium,Italic"
  ],
  "Fanatika One": [
    "Normal,Normal"
  ],
  "RollingStone": [
    "Normal,Normal"
  ],
  "Nails": [
    "Normal,Normal"
  ],
  "Arial Rounded MT Bold": [
    "Bold,Normal"
  ],
  "Scramble": [
    "Normal,Normal"
  ],
  "Qirof": [
    "Normal,Normal"
  ],
  "VTC Letterer Pro": [
    "Normal,Normal"
  ],
  "Helvetica67-CondensedMedium": [
    "Medium,Normal"
  ],
  "Smythe": [
    "Normal,Normal"
  ],
  "SimHei": [
    "Normal,Normal"
  ],
  "Helvetica Light": [
    "Light,Normal",
    "Light,Oblique",
    "Light,Italic"
  ],
  "ArcherPro Extra Light": [
    "ExtraLight,Normal",
    "ExtraLight,Italic"
  ],
  "Elsie": [
    "Normal,Normal"
  ],
  "city burn night after night and we spraypaint the walls": [
    "Normal,Normal"
  ],
  "Off Kilter R (BRK)": [
    "Normal,Normal"
  ],
  "Year 2000 Replicant": [
    "Normal,Normal"
  ],
  "Interstate": [
    "Normal,Normal",
    "Bold,Normal"
  ],
  "Quadrangle": [
    "Normal,Normal"
  ],
  "HelveticaNeueLT Std Thin": [
    "Thin,Normal"
  ],
  "HebrewUniversal": [
    "Normal,Normal"
  ],
  "Industrial": [
    "Normal,Normal"
  ],
  "Overlock": [
    "Black,Normal",
    "Black,Italic",
    "Bold,Normal",
    "Bold,Italic",
    "Normal,Italic",
    "Normal,Normal"
  ],
  "Vivienne": [
    "Normal,Normal"
  ],
  "Sagittarius": [
    "Normal,Normal"
  ],
  "Merienda": [
    "Bold,Normal",
    "Normal,Normal"
  ],
  "STZhongsong": [
    "Normal,Normal"
  ],
  "STXihei": [
    "Normal,Normal"
  ],
  "Jangly Bounce": [
    "Normal,Normal"
  ],
  "Walrod": [
    "Normal,Normal"
  ],
  "Xomic": [
    "Normal,Normal"
  ],
  "ER Kurier KOI-8": [
    "Bold,Italic"
  ],
  "Yellow Dog": [
    "Normal,Normal"
  ],
  "Denmark": [
    "Medium,Normal"
  ],
  "YanksHand": [
    "Medium,Normal"
  ],
  "Gill Sans Ultra Bold Condensed": [
    "ExtraBold,Normal"
  ],
  "Franklin Gothic Demi Cond": [
    "SemiBold,Normal"
  ],
  "Nameless Harbor": [
    "Normal,Normal"
  ],
  "Smiley": [
    "Medium,Normal"
  ],
  "Helvetica LT Std Compressed": [
    "Normal,Normal"
  ],
  "STFangsong": [
    "Normal,Normal"
  ],
  "Quorum Md BT": [
    "Normal,Normal"
  ],
  "Aladin": [
    "Normal,Normal"
  ],
  "Poor Richard": [
    "Normal,Normal"
  ],
  "Scritzy": [
    "Normal,Normal"
  ],
  "Kabel": [
    "Normal,Normal"
  ],
  "Starburst": [
    "Normal,Italic"
  ],
  "Gotham Black": [
    "Black,Normal"
  ],
  "Nexa Slab Bold Oblique ": [
    "Bold,Oblique"
  ],
  "Intro Bold Italic": [
    "Bold,Italic"
  ],
  "Zebra Parade": [
    "Normal,Normal"
  ],
  "KG Ten Thousand Reasons": [
    "Normal,Normal"
  ],
  "Helvetica 2 BQ ": [
    "Medium,Italic",
    "Medium,Normal"
  ],
  "nunacom": [
    "Normal,Normal"
  ],
  "Regal box": [
    "Normal,Normal"
  ],
  "Mars Police": [
    "Normal,Normal"
  ],
  "Sarpanch SemiBold": [
    "SemiBold,Normal"
  ],
  "Independence": [
    "Normal,Normal"
  ],
  "Microsoft JhengHei": [
    "Normal,Normal",
    "Bold,Normal"
  ],
  "Core Sans A 45 Regular": [
    "Normal,Italic",
    "Normal,Normal"
  ],
  "Letter Set C": [
    "Normal,Normal"
  ],
  "MT Extra": [
    "Normal,Normal"
  ],
  "LTInagur": [
    "Normal,Italic"
  ],
  "Proxima Nova Cn Rg": [
    "Normal,Normal",
    "Normal,Italic"
  ],
  "Helvetica Compressed": [
    "Medium,Normal"
  ],
  "Helvetica33-ExtendedThin": [
    "Thin,Normal"
  ],
  "Nexa Slab Heavy": [
    "Black,Normal"
  ],
  "Helvetica Condensed Black": [
    "Black,Normal"
  ],
  "Woods Cree": [
    "Normal,Normal"
  ],
  "Interstate Mono": [
    "Bold,Normal",
    "Normal,Normal"
  ],
  "Helvetica Inserat Cyrillic Upri": [
    "Medium,Normal"
  ],
  "Magic:the Gathering": [
    "Normal,Normal"
  ],
  "Narcosis": [
    "Normal,Oblique"
  ],
  "RoteFlora": [
    "Normal,Normal"
  ],
  "NudE": [
    "Normal,Normal"
  ],
  "Intro Thin Alt": [
    "Thin,Normal"
  ],
  "Irezumi": [
    "Normal,Normal"
  ],
  "7th Service Condensed": [
    "Normal,Normal"
  ],
  "SKULL TS 2": [
    "Normal,Normal"
  ],
  "Eraser": [
    "Medium,Normal"
  ],
  "Swinkydad": [
    "Bold,Normal"
  ],
  "SteveHandwriting": [
    "Medium,Normal"
  ],
  "Yanone Kaffeesatz Bold": [
    "Bold,Normal"
  ],
  "HelveticaNeue ThinExt": [
    "Thin,Oblique"
  ],
  "HelveticaCndObl-Thin": [
    "Thin,Normal"
  ],
  "Mixed up": [
    "Normal,Normal"
  ],
  "Open Sans Extrabold": [
    "ExtraBold,Normal",
    "ExtraBold,Italic"
  ],
  "hebrew": [
    "Medium,Normal"
  ],
  "SILDoulos IPA93": [
    "Normal,Normal"
  ],
  "Gill Sans MT": [
    "Bold,Italic",
    "Bold,Normal",
    "Normal,Italic",
    "Normal,Normal"
  ],
  "I hate Comic Sans": [
    "Normal,Normal"
  ],
  "Saulteaux": [
    "Normal,Normal"
  ],
  "Tw Cen MT Condensed Extra Bold": [
    "ExtraBold,Normal"
  ],
  "Helvetica Diagonal BQ": [
    "Medium,Normal"
  ],
  "Goudy Stout": [
    "Normal,Normal"
  ],
  "Arabic Web": [
    "Normal,Normal"
  ],
  "National Primary": [
    "Normal,Normal"
  ],
  "Lilith": [
    "Medium,Normal"
  ],
  "Shotgun BT": [
    "Normal,Normal"
  ],
  "Agency FB": [
    "Bold,Normal",
    "Normal,Normal"
  ],
  "Franklin Gothic Heavy": [
    "Black,Normal",
    "Black,Italic"
  ],
  "Jerk": [
    "Normal,Normal"
  ],
  "Core Sans A 75 ExtraBold": [
    "ExtraBold,Italic",
    "ExtraBold,Normal"
  ],
  "Good Head": [
    "Normal,Normal"
  ],
  "HelveticaExtO 4": [
    "Normal,Normal"
  ],
  "Great Moravia": [
    "Normal,Normal",
    "Bold,Normal",
    "Bold,Italic",
    "Normal,Italic"
  ],
  "Nexa Slab Thin": [
    "Thin,Normal"
  ],
  "Intro Cond Black Free": [
    "Black,Normal"
  ],
  "SuperFrench": [
    "Normal,Normal"
  ],
  "Intro Black Italic": [
    "Black,Italic"
  ],
  "Luteous Industrious": [
    "Normal,Normal"
  ]
};

